import { useState } from "react";
import SideBar from "../../components/UserDashboard/SideBar";
import "../../styles/UserDashboard/Home.scss";
import { Link } from "react-router-dom";

import {
  InputLabel,
  OutlinedInput,
  Menu,
  MenuItem,
  Typography,
  Tooltip,
} from "@mui/material";
import Chart from "chart.js/auto";
import { useEffect } from "react";
import { useRef } from "react";
import Search from "../../components/UserDashboard/Search";
import { useSelector } from "react-redux";
import jwt_decode from "jwt-decode";
import {
  bookDate,
  emissionDataInRange,
  getAvailableDates,
  getLatestWeekOffset,
  getTotalOffset,
  updateOffsetGoal,
} from "../../apis/UserDashboard/dashboard";
import { toast } from "react-toastify";
import moment from "moment";
import {
  getDatabase,
  ref,
  onValue,
  orderByChild,
  equalTo,
  query,
} from "firebase/database";
import { getKyc, getUserInfo, sendFakeData } from "../../apis/General/users";
import Kyc from "../../components/UserDashboard/Kyc";
import { useDispatch } from "react-redux";
import { ethers } from "ethers";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { PaystackButton } from "react-paystack";
// import { createIssue } from "../../apis/Support";
import * as echarts from "echarts";
import { PDFDownloadLink } from "@react-pdf/renderer";
import EmissionsReport from "../ThirdParty/EmissionReport";
import formatDate from "../../utils/formatDate";
import {viewComment} from "../../apis/UserDashboard/dashboard"
const config = {
  reference: new Date().getTime().toString(),
  email: "user@example.com",
  amount: 20000, //Amount is in the country's lowest currency. E.g Kobo, so 20000 kobo = N200
  // currency: "USD",
  publicKey: "pk_test_3f715236ee25c842649abc6a3c013258a37f9b1c",
};

const Home = () => {
  const handlePaystackSuccessAction = (reference) => {
    // Implementation for whatever you want to do with reference and after success call.
    console.log("reference", reference);
  };

  // you can call this function anything
  const handlePaystackCloseAction = () => {
    // implementation for  whatever you want to do when the Paystack dialog closed.
    console.log("closed");
  };

  const componentProps = {
    ...config,
    text: "Paystack Button Implementation",
    onSuccess: (reference) => handlePaystackSuccessAction(reference),
    onClose: handlePaystackCloseAction,
  };

  const auth = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const chartRef = useRef(null);
  const chartInstance = useRef(null);

  const [openFaq, setOpenFaq] = useState(null);
  const [openDownloadReport, setOpenDownloadReport] = useState(false);
  const [offsetGoal, setOffsetGoal] = useState(auth?.userInfo?.offsetGoal);
  const [offset, setOffset] = useState(0);
  const mediaRef = useRef(null);
  const [modalOpenTwo, setModalOpenTwo] = useState(false);
  const [modalOpenThree, setModalOpenThree] = useState(false);
  const [tutorialModal, setTutorialModal] = useState(false);
  const [runTutorial, setRunTutorial] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [newGoal, setNewGoal] = useState("");
  const [totalEmision, setTotalEmission] = useState(0);
  const [weeklyEmissionDays, setWeeklyEmissionDays] = useState([]);
  const [weeklyEmission, setWeeklyEmission] = useState([]);
  const [emissionOffsetData, setEmissionOffsetData] = useState([]);
  const [generalLoading, setGeneralLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [fakeloading, setFakeLoading] = useState(false);
  const [inRangeLoading, setInRangeLoading] = useState(false);
  const [error, setError] = useState(null);
  const [activeTag, setActiveTag] = useState("");
  const [currentIndex, setCurrentIndex] = useState(0);
  const [registeredDevices, setRegisteredDevices] = useState([]);
  const [cardVisible, setCardVisible] = useState("");
  const [foundDevice, setFoundDevice] = useState("");
  const [user, setUser] = useState(null);
  const [solarType, setSolarType] = useState("");
  const [renewableSource, setRenewableSource] = useState("");
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const db = getDatabase();
  const open = Boolean(anchorEl);
  const [fakeData, setFakeData] = useState(false);
  const [fabData, setFabData] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [scheduleSuccess, setScheduleSuccess] = useState(null);
  const [lastSyncDate, setLastSyncDate] = useState(null);
  const [emissionObject, setEmissionObject] = useState({});

  const [events, setEvents] = useState([]);

  const [currentMonth, setCurrentMonth] = useState(new Date().getMonth());
  const [currentYear, setCurrentYear] = useState(new Date().getFullYear());
  const [availableDates, setAvailableDates] = useState([]);
  const [bookedDates, setBookedDates] = useState([]);
  const [bookedDateLoading, setBookedDateLoading] = useState(false);
  const [ccrtValue, setCcrtValue] = useState(0);
  const [sla, setSla] = useState(false);
  const [firstDate, setFirstDate] = useState(null);
  const [lastDate, setLastDate] = useState(null);
  const [ndcCalendar, setNdcCalendar] = useState(false);
  const [reportTotalEmission, setReportTotalEmission] = useState(null);
  const [comment , setComment ] = useState([])
  const listenersRef = useRef([]);

  const fetchDatesFromStorage = async () => {
    const response = await getAvailableDates(auth?.token);
    console.log("response getAvailableDates", response);
    if (response?.data?.statusCode === 200) {
      setAvailableDates(response?.data?.message[2]?.values);
    } else {
      toast.error(response?.data?.message);
    }

    // Fetch data from backend or local storage and update state
    // Available dates

    const events = [
      ...availableDates.map((date) => ({
        start: new Date(date),
        end: new Date(date),
        title: "Available",
        isAvailable: true,
      })),
      ...bookedDates.map((date) => ({
        start: new Date(date),
        end: new Date(date),
        title: "Booked",
        isAvailable: false,
      })),
    ];

    setEvents(events);
  };

  const getComment = async()=>{
    
    const getID = await getKyc(auth?.userInfo?.id, auth?.token);
    console.log("getKyc", getID?.data?.message.id);
    const CommentResponse =  await viewComment(getID?.data?.message.id, auth?.token)
    setComment(CommentResponse)
    console.log("CommentResponse",CommentResponse.data.additionalComment
)
  }

  useEffect(() => {
    getComment()
    // Fetch available and booked dates from backend or local storage
    fetchDatesFromStorage();
  }, []);

  const handleDateClick = (date) => {
    // Check if date is available
    if (availableDates?.includes(date)) {
      console.log("datelop", date);
      setSelectedDate(date);
      // // Book the date
      // setBookedDates([...bookedDates, date]);
      // setAvailableDates(availableDates.filter((d) => d !== date));

      // // Save the booking to backend or local storage
      // saveBookingToStorage(date);
    }
  };


  const saveBookingToStorage = (date) => {
    // Save the booked date to backend or local storage
  };

  const handleIncrementMonth = () => {
    if (currentMonth === 11) {
      setCurrentMonth(0);
      setCurrentYear(currentYear + 1);
    } else {
      setCurrentMonth(currentMonth + 1);
    }
  };

  const handleDecrementMonth = () => {
    if (currentMonth === 0) {
      setCurrentMonth(11);
      setCurrentYear(currentYear - 1);
    } else {
      setCurrentMonth(currentMonth - 1);
    }
  };

  const renderCalendarGrid = () => {
    const daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    const startDay = new Date(currentYear, currentMonth, 1).getDay();
    const daysInMonth = new Date(currentYear, currentMonth + 1, 0).getDate();

    const rows = [];
    let currentDay = 1;

    // console.log("perimiter", new Date().getMonth());
    // console.log("perimiter", new Date().getFullYear());

    // Create the calendar grid
    for (let i = 0; i < 6; i++) {
      const days = [];

      for (let j = 0; j < 7; j++) {
        if (i === 0 && j < startDay) {
          // Render empty cells for days before the first of the month
          days.push(<div key={`empty-${j}`} className="calendar-cell"></div>);
        } else if (currentDay > daysInMonth) {
          // Finish rendering the calendar grid
          break;
        } else {
          // Render the date cell
          const dateString = `${currentYear}-${String(
            currentMonth + 1
          ).padStart(2, "0")}-${String(currentDay).padStart(2, "0")}`;
          // console.log("availableDates", availableDates);
          const isAvailable = availableDates?.includes(dateString);
          const isBooked = !availableDates?.includes(dateString);
          const cellClassName = `calendar-cell${isAvailable ? " available" : ""
            }${isBooked ? " booked" : ""}`;

          days.push(
            <Tooltip
              title={
                !availableDates?.includes(dateString) && (
                  <Typography variant="h6">This date is unavailable</Typography>
                )
              }
            >
              <div
                key={dateString}
                className={
                  selectedDate === dateString
                    ? `active-date ${cellClassName}`
                    : cellClassName
                }
                onClick={() => handleDateClick(dateString)}
              >
                {currentDay}
              </div>
            </Tooltip>
          );
          currentDay++;
        }
      }

      rows.push(
        <div key={`row-${i}`} className="calendar-row">
          {days}
        </div>
      );
    }

    return (
      <div className="calendar-grid">
        <div className="calendar-row calendar-header">
          {daysOfWeek.map((day, index) => (
            <div key={`header-${index}`} className="calendar-cell">
              {day}
            </div>
          ))}
        </div>
        {rows}
      </div>
    );
  };

  const renderCalendarGridRange = () => {
    const daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    const startDay = new Date(currentYear, currentMonth, 1).getDay();
    const daysInMonth = new Date(currentYear, currentMonth + 1, 0).getDate();

    const rows = [];
    let currentDay = 1;

    console.log("perimiter", new Date().getMonth());
    console.log("perimiter", new Date().getFullYear());

    // Create the calendar grid
    for (let i = 0; i < 6; i++) {
      const days = [];

      for (let j = 0; j < 7; j++) {
        if (i === 0 && j < startDay) {
          // Render empty cells for days before the first of the month
          days.push(<div key={`empty-${j}`} className="calendar-cell"></div>);
        } else if (currentDay > daysInMonth) {
          // Finish rendering the calendar grid
          break;
        } else {
          // Render the date cell
          const dateString = `${currentYear}-${String(
            currentMonth + 1
          ).padStart(2, "0")}-${String(currentDay).padStart(2, "0")}`;
          const cellClassName = `calendar-cell ndc-calendar-date`;

          days.push(
            <div
              key={dateString}
              className={
                firstDate === dateString
                  ? `active-date ${cellClassName}`
                  : lastDate === dateString
                    ? `active-date ${cellClassName}`
                    : parseInt(firstDate?.split("-")[2]) <
                      parseInt(dateString?.split("-")[2]) &&
                      parseInt(lastDate?.split("-")[2]) >
                      parseInt(dateString?.split("-")[2])
                      ? `subsidiary-date ${cellClassName}`
                      : cellClassName
              }
              onClick={() => handleDateRangeClick(dateString)}
            >
              {currentDay}
            </div>
          );
          currentDay++;
        }
      }

      rows.push(
        <div key={`row-${i}`} className="ndc-calendar-row">
          {days}
        </div>
      );
    }

    return (
      <div className="calendar-grid">
        <div className="ndc-calendar-row calendar-header">
          {daysOfWeek.map((day, index) => (
            <div key={`header-${index}`} className="calendar-cell">
              {day}
            </div>
          ))}
        </div>
        {rows}
      </div>
    );
  };

  const handleEventClick = (event) => {
    // Check if the event is available
    if (event.title === "Available") {
      // Book the date
      // Save the booking to backend or local storage
    }
  };

  const handleFromChange = (e) => {
    if (Date.now() >= Date.parse(e.target.value)) {
      e.preventDefault();
      setTo("");
      setFrom(e.target.value);
    } else {
      alert("Invalide date");
    }
  };

  function convertDateToTimestamp(dateString) {
    // Create a Date object from the input date string
    const date = new Date(dateString);

    // Return the timestamp in milliseconds
    return date.getTime();
  }

  const handleGetEmissionDataInRange = async () => {
    // if (Date.now() >= Date.parse(e.target.value)) {
    // if (Date.parse(e.target.value) > Date.parse(from)) {
    setInRangeLoading(true);
    // e.preventDefault();

    // setTo(e.target.value);
    // console.log('from', from, Date.parse(from), 'to', e.target.value, Date.parse(e.target.value));
    const response = await emissionDataInRange(
      // Date.parse(from),
      // Date.parse(e.target.value),
      convertDateToTimestamp(firstDate) > 0
        ? convertDateToTimestamp(firstDate)
        : "",
      convertDateToTimestamp(lastDate) > 0
        ? convertDateToTimestamp(lastDate)
        : "",
      auth?.token
    );
    console.log("emissionDataInRange", response);

    if (response?.data?.message?.length > 0) {
      const emissionTemp = response?.data?.message?.reduce(
        (sum, item) => sum + Number(item?.totalGhgEmission),
        0
      );
      setReportTotalEmission(emissionTemp?.toFixed(4))
      const sortedData = response?.data?.message?.sort((a, b) => {
        // Convert createdAt to numbers and compare
        return Number(b.createdAt) - Number(a.createdAt);
      });
      const oneDayInMs = 24 * 60 * 60 * 1000; // 86400000
      const correctedData = sortedData.map(item => ({
        ...item,
        createdAt: (parseInt(item.createdAt) - oneDayInMs).toString()
      }));

      console.log("sortedData", correctedData);

      setEmissionOffsetData(correctedData);
    }
    setNdcCalendar(false);
    setInRangeLoading(false);
    // } else {
    //   alert('"To" date has to be ahead of "From" date');
    // }
    // } else {
    //   alert("Invalide date");
    // }
  };


  useEffect(() => {
    handleGetEmissionDataInRange();
  }, []);
  console.log("auth", auth);

  // useEffect(() => {
  //   if (auth?.userInfo?.kycStatus === "n/a") {
  //     setFakeData(true)
  //   }
  // }, []);

  /*********web3*********/
  // const { address, isConnected } = useAccount();
  /*********web3*********/
  const fetchUserInfo = async () => {
    setGeneralLoading(true);
    const response = await getUserInfo(auth?.userInfo?.id, auth?.token);
    console.log(
      "response?.data?.message?.registeredDevices",
      response?.data?.message?.registeredDevices
    );
    setUser(response?.data?.message);


    setRegisteredDevices(response?.data?.message?.registeredDevices);
    setGeneralLoading(false);
  };
  useEffect(() => {
    fetchUserInfo();
  }, []);

  // useEffect(() => {
  //   const checkOnboarded = localStorage.getItem("onboarded");

  //   // if (
  //   //   checkOnboarded !== "true" &&
  //   //   auth?.userInfo?.trdPtyKycStatus === "in_progress"
  //   // ) {
  //   //   setTutorialModal(true);
  //   // }
  //   if (checkOnboarded !== "true") {
  //     setTutorialModal(true);
  //   } else if (!auth?.userInfo?.iotInstScheduled) {
  //     setFakeData(true);
  //   }
  // }, [auth]);

  useEffect(() => {
    console.log("first point");
    const checkOnboarded = localStorage.getItem("onboarded");

    const intervalId = setInterval(() => {
      console.log("second point");
      if (checkOnboarded === "true") {
        console.log("third point");

        clearInterval(intervalId);
      } else if (runTutorial) {
        console.log("fourth point");
        setModalOpenThree(true);
        if (currentIndex > 9) {
          clearInterval(intervalId);
          setModalOpenThree(false);
          localStorage.setItem("onboarded", "true");
          if (!auth?.userInfo?.iotInstScheduled) {
            setFakeData(true);
          }
        } else if (currentIndex === 0) {
          const cardElement = document.getElementById("card");

          if (cardElement) {
            cardElement.scrollIntoView({ behavior: "smooth" });
          }
          setCurrentIndex(currentIndex + 1);
        } else if (currentIndex === 3) {
          const cardElement = document.getElementById("container");

          if (cardElement) {
            cardElement.scrollIntoView({ behavior: "smooth" });
          }
          setCurrentIndex(currentIndex + 1);
        } else if (currentIndex === 5) {
          const cardElement = document.getElementById("table");

          if (cardElement) {
            cardElement.scrollIntoView({ behavior: "smooth" });
          }
          setCurrentIndex(currentIndex + 1);
        } else if (currentIndex === 6) {
          const cardElement = document.getElementById("card");

          if (cardElement) {
            cardElement.scrollIntoView({ behavior: "smooth" });
          }
          setCurrentIndex(currentIndex + 1);
        } else {
          setCurrentIndex(currentIndex + 1);
        }
      } else {
        clearInterval(intervalId);
      }
    }, 10000);

    return () => {
      clearInterval(intervalId);
    };
  });

  const tableRef = ref(db, "prod-emission-data");
  const tableRef2 = ref(db, "sensors");
  const tableRef3 = ref(db, "events");

  const fetchDataForDevice = async (deviceId) => {
    const deviceQuery = query(
      tableRef,
      orderByChild("deviceId"),
      equalTo(deviceId)
    );
    return new Promise((resolve, reject) => {
      onValue(
        deviceQuery,
        (snapshot) => {
          if (snapshot.exists()) {
            resolve(Object.values(snapshot.val()));
          } else {
            resolve([]);
          }
        },
        (error) => {
          reject(error);
        }
      );
    });
  };

  useEffect(() => {
    console.log("hello hammed");

    // Guard clause if no registered devices
    if (!registeredDevices || registeredDevices.length === 0) {
      return;
    }

    // Track processed devices
    const processedDevices = {};

    // Clear existing listeners before setting new ones
    listenersRef.current.forEach((unsubscribe) => unsubscribe());
    listenersRef.current = [];

    registeredDevices.forEach((deviceId) => {
      const deviceQuery = query(
        tableRef,
        orderByChild("deviceId"),
        equalTo(deviceId.deviceId)
      );

      const unsubscribe = onValue(deviceQuery, (snapshot) => {
        if (snapshot.exists()) {
          const data = Object.values(snapshot.val());

          const deviceTotalEmission = data.reduce(
            (sum, item) => sum + item.emissionValue,
            0
          );

          processedDevices[deviceId.deviceId] = deviceTotalEmission;

          // Check if all devices have been processed
          if (
            Object.keys(processedDevices).length === registeredDevices.length
          ) {
            console.log("Final processed devices:", processedDevices);
            setEmissionObject((prevState) => {
              // Only update if the new state is different
              const isStateChanged =
                JSON.stringify(prevState) !== JSON.stringify(processedDevices);
              return isStateChanged ? processedDevices : prevState;
            });
          }

          const mostRecentObject = data.reduce((latest, current) => {
            return parseInt(current.createdAt) > parseInt(latest.createdAt)
              ? current
              : latest;
          });

          if (mostRecentObject?.createdAt > lastSyncDate) {
            setLastSyncDate(mostRecentObject?.createdAt);
          }
        } else {
          console.log(`No data found for ${deviceId.deviceId}`);

          processedDevices[deviceId.deviceId] = 0;

          // Check if all devices have been processed
          if (
            Object.keys(processedDevices).length === registeredDevices.length
          ) {
            setEmissionObject((prevState) => {
              // Only update if the new state is different
              const isStateChanged =
                JSON.stringify(prevState) !== JSON.stringify(processedDevices);
              return isStateChanged ? processedDevices : prevState;
            });
          }
        }
      });

      listenersRef.current.push(unsubscribe);
    });

    setGeneralLoading(false);

    // Cleanup function
    return () => {
      listenersRef.current.forEach((unsubscribe) => unsubscribe());
      listenersRef.current = [];
    };
  }, [registeredDevices, tableRef]);

  useEffect(() => {
    console.log("emissionObject emissionObject", emissionObject);
    const emissionTotal = Object.values(emissionObject).reduce(
      (sum, emission) => sum + emission,
      0
    );
    setTotalEmission(emissionTotal / 1000);
    console.log("TOTAL EMISSION", emissionTotal)
  }, [emissionObject]);

  const handleModalOpenTwo = () => {
    setModalOpenTwo(true);
    handleClose();
  };

  const handleModalCloseTwo = (e) => {
    if (e.target.classList.contains("goal_modal_container")) {
      setModalOpenTwo(false);
    }
  };
  const handleFabDataClose = (e) => {
    if (e.target.classList.contains("fake_data_modal")) {
      setFabData(false);
    }
  };
  const handleScheduleDataClose = (e) => {
    if (e.target.classList.contains("schedule-success_data_modal")) {
      setScheduleSuccess(false);
    }
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSetGoal = async (e) => {
    e.preventDefault();
    setLoading(true);
    // console.log("offsetGoal", offsetGoal);
    const response = await updateOffsetGoal(newGoal, auth?.token);
    // console.log("response", response);
    // console.log("decode", jwt_decode(response?.data?.token));
    if (response?.data?.statusCode === 200) {
      setModalOpenTwo(false);
      setOffsetGoal(newGoal);
      setNewGoal("");

      localStorage.removeItem("token");
      localStorage.setItem("token", response?.data?.token);

      dispatch({
        type: "USER_LOGIN_SUCCESS",
        payload: {
          token: response?.data?.token,
        },
      });
    } else {
      alert(response?.data?.message);
    }
    setLoading(false);
  };

  const handleGetTotalOffset = async () => {
    setGeneralLoading(true);
    const response = await getTotalOffset(auth?.token);
    console.log("getTotalOffset", response);
    if (response?.data?.statusCode === 200) {
      setOffset(response?.data?.message);
    } else {
      setOffset(0);
    }
    setGeneralLoading(false);
  };
  const handleGetLatestWeekOffset = async () => {
    setGeneralLoading(true);
    const response = await getLatestWeekOffset(auth?.token);
    console.log("pheel", response);
    const sortedData = response?.data?.message.sort((a, b) => parseInt(a.createdAt) - parseInt(b.createdAt));
    const oneDayInMs = 24 * 60 * 60 * 1000; // 86400000

    const correctedData = sortedData.map(item => ({
      ...item,
      createdAt: (parseInt(item.createdAt) - oneDayInMs).toString()
    }));
    if (response?.data?.statusCode === 200) {
      const temp = correctedData?.map((item) => {
        const date = new Date(Number(item.createdAt));
        const monthNames = [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ];
        const month = monthNames[date.getMonth()];
        const day = date.getDate();
        return `${month} ${day}`;
      });
      console.log("at it", temp);

      setWeeklyEmissionDays(temp);
      const temp2 = correctedData?.map(
        (item) =>
          Number(item?.totalGhgEmission).toFixed(4) < 0.0001
            ? (Number(item?.totalGhgEmission)).toFixed(7)
            : Number(item?.totalGhgEmission).toFixed(4)

        // console.log('item.totalGhgEmission', item.totalGhgEmission)
      );
      console.log("temo", temp2);
      setWeeklyEmission(temp2);
    } else {
      // toast.error("Something went wrong");
    }
    setGeneralLoading(false);
  };

  useEffect(() => {
    handleGetTotalOffset();
    handleGetLatestWeekOffset();
  }, []);

  // useEffect(() => {
  //   if (weeklyEmission?.length > 0) {
  //     const ctx = document.getElementById("myChart");

  //     const myChart = new Chart(ctx, {
  //       type: "line",
  //       data: {
  //         labels: weeklyEmissionDays,
  //         datasets: [
  //           {
  //             label: "Emission Tracked",
  //             data: weeklyEmission,
  //             borderWidth: 1,
  //             backgroundColor: "#006633",
  //           },
  //         ],
  //       },
  //       options: {
  //         responsive: true,
  //         maintainAspectRatio: false,
  //         plugins: {
  //           tooltip: {
  //             callbacks: {
  //               label: function (tooltipItem) {
  //                 return `${tooltipItem?.label}`;
  //               },
  //               label: function (tooltipItem) {
  //                 return `${tooltipItem?.formattedValue}tCO2`;
  //               },
  //             },
  //           },
  //         },
  //         scales: {
  //           y: {
  //             beginAtZero: true,
  //           },
  //         },
  //       },
  //     });

  //     return () => {
  //       myChart.destroy();
  //     };
  //   }
  // }, [, weeklyEmission]);

  useEffect(() => {
  const doughnut = document.getElementById("doughnutChart");

  const doughnutChart = new Chart(doughnut, {
    type: "doughnut",
    data: {
      datasets: [
        {
          // label: "Total Emission", // keep commented out
          data: [
            totalEmision.toFixed(4) < 0.0001
              ? (totalEmision).toFixed(7)
              : totalEmision.toFixed(4),
          ],
          borderWidth: 1,
          backgroundColor: "#2C9963",
        },
      ],
    },
    options: {
      cutout: "65%", 
      plugins: {
        tooltip: {
          enabled: false,
        },
        legend: {
          display: false,
        },
      },
    },
  });

  return () => {
    doughnutChart.destroy();
  };
}, [totalEmision, weeklyEmission]);

  const getDeviceId = async () => {
    const deviceQuery = query(
      tableRef2,
      orderByChild("userId"),
      equalTo(auth?.userInfo?.id)
    );
    return onValue(deviceQuery, (snapshot) => {
      if (snapshot.exists()) {
        const data = Object.values(snapshot.val());
        // console.log("devices found", data);
        return data[0];
      } else {
        console.log(`No data found`);
      }
      setLoading(false);
    });
  };

  const handleGetSingleIotDevice = async () => {
    let foundDeviceTemp;
    const deviceQuery = query(
      tableRef2,
      orderByChild("userId"),
      equalTo(auth?.userInfo?.id)
    );
    return onValue(deviceQuery, (snapshot) => {
      if (snapshot.exists()) {
        const data = Object.values(snapshot.val());
        console.log("devices found", data);
        foundDeviceTemp = data[0];
        setFoundDevice(data[0]);
        console.log(
          'foundDeviceTemp?.id.split("-")',
          foundDeviceTemp?.id.split("-")
        );
        if (foundDeviceTemp?.id.split("-")[0] === "GF") {
          if (foundDeviceTemp?.id.split("-")[1] === "HP") {
            setRenewableSource("hydro-power");
          } else if (foundDeviceTemp?.id.split("-")[1] === "SLUT") {
            setSolarType("utility");
          } else {
            setSolarType("roof-top");
          }
        }
      } else {
        console.log(`No data found`);
      }
    });
  };

  useEffect(() => {
    handleGetSingleIotDevice();
  }, []);
  const handleSendFakeData = async () => {
    console.log("foundDevice", foundDevice, "solarType", solarType);
    if (!foundDevice) {
      toast.error("Please register a device before requesting for data");
      return;
    }
    setFakeLoading(true);
    const response = await getKyc(auth?.userInfo?.id, auth?.token);
    console.log("getKyc", response?.data?.message.id);

    const response1 = await sendFakeData(
      response?.data?.message?.facilityCategory === "green"
        ? "green-project"
        : response?.data?.message?.sustainabilitySolution,
      foundDevice?.id,
      solarType,
      renewableSource,
      auth?.token
    );
    console.log("response1", response1);
    if (response1?.data?.statusCode === 200) {
      toast.success("You've received emision data");
      setFakeData(false);
    } else if (response?.data?.errorMessage) {
      toast.error(response?.data?.errorMessage);
    } else if (response?.status === 504) {
      toast.error(response?.data?.message);
    } else {
      toast.error("Unable to get fabricated data");
    }
    setFakeLoading(false);
  };

  const handleSchedule = async () => {
    if (!sla) {
      alert("Please confirm you have read and agreed to the terms of the SLA");
      return;
    }
    if (!selectedDate) {
      alert("Please select a date before proceeding");
      return;
    }
    setBookedDateLoading(true);
    const response = await bookDate(selectedDate, auth?.token);
    console.log("response", response);
    if (response?.data?.statusCode === 200) {
      setScheduleSuccess(true);
      setFakeData(false);
      localStorage.setItem("token", response?.data?.token);
      dispatch({
        type: "USER_LOGIN_SUCCESS",
        payload: {
          token: response?.data?.token,
        },
      });
    } else {
      toast.error(response?.data?.message);
    }
    // setScheduleSuccess(true);
    setBookedDateLoading(false);
  };

  const getWalletBalance = async () => {
    try {
      const response = await getKyc(auth?.userInfo?.id, auth?.token);
      console.log("getKyc", response?.data?.message?.id);
      const eventsQuery = query(
        tableRef3,
        orderByChild("addressToRecord"),
        equalTo(response?.data?.message?.walletAddress)
      );
      return onValue(eventsQuery, (snapshot) => {
        if (snapshot.exists()) {
          const data = Object.values(snapshot.val());
          const filteredData = data
            .filter((item) => item.type === "Carbon Credits Transferred")
            .reduce((sum, item) => sum + item.creditIssued, 0);

          setCcrtValue(filteredData);
        } else {
          console.log(`No carbon credit data found for this user`);
        }
        setLoading(false);
      });
    } catch (error) {
      console.log("ERROR", error);
      // toast.error("Something went wrong");
    }
  };
  useEffect(() => {
    getWalletBalance();
  }, []);

  // const handleCreateIssue = async () => {
  //   const response = await createIssue();
  //   console.log("createIssue", response);
  // };

  // useEffect(() => {
  //   handleCreateIssue();
  // }, []);

  useEffect(() => {
    // Initialize chart
    const chartDom = document.getElementById("myChartg");
    if (!chartDom) return;

    // Create chart instance
    chartInstance.current = echarts.init(chartDom);

    const option = {
      title: {
        text: "Carbon Tracked",
      },
      tooltip: {},
      xAxis: {
        type: "category",
        data: weeklyEmissionDays,
      },
      yAxis: {
        type: "value",
      },
      color: "#00AED9",
      series: [
        {
          name: "Carbon Tracked (tcO2)",
          data: weeklyEmission,
          type: "bar",
        },
      ],
    };

    // Set chart options
    chartInstance.current.setOption(option);

    // Add resize event listener
    const handleResize = () => {
      if (chartInstance.current) {
        chartInstance.current.resize();
      }
    };

    window.addEventListener("resize", handleResize);

    // Clean up function
    return () => {
      window.removeEventListener("resize", handleResize);
      if (chartInstance.current) {
        chartInstance.current.dispose();
        chartInstance.current = null;
      }
    };
  }, [weeklyEmission, weeklyEmissionDays]);

  // Update chart when data changes
  useEffect(() => {
    if (chartInstance.current) {
      chartInstance.current.setOption({
        xAxis: {
          data: weeklyEmissionDays
        },
        series: [
          {
            data: weeklyEmission
          }
        ]
      });
    }
  }, [weeklyEmission, weeklyEmissionDays]);

  const handleNdcCalendarClick = () => {
    setNdcCalendar(!ndcCalendar);
  };

  const clearDateSelection = () => {
    setFirstDate(null);
    setLastDate(null);
  };

  const handleDateRangeClick = (date) => {
    if (!firstDate) {
      setFirstDate(date);
    } else if (firstDate && !lastDate) {
      if (parseInt(firstDate?.split("-")[2]) > parseInt(date?.split("-")[2])) {
        setLastDate(firstDate);
        setFirstDate(date);
      } else {
        setLastDate(date);
      }
    } else if (!!firstDate && !!lastDate) {
      setFirstDate(date);
      setLastDate(null);
    }
  };

  return (
    <div className="dashboard_home">
      <div className="sidebar_container">
        <SideBar />
        {/* <div
          className={
            currentIndex === 7 ? "tag validation" : "tag validation no_tag"
          }
        >
          This shows the process of getting confirmation on the emission tracked
        </div> */}
        <div
          className={
            currentIndex === 8 ? "tag verification" : "tag verification no_tag"
          }
        >
          This shows checking & confirming that all data is accurate and it is
          displayed in form of a progress bar.
        </div>
        <div
          className={currentIndex === 9 ? "tag credit" : "tag credit no_tag"}
        >
          Shows your CO2 credit balance, history and allocated at different
          intervals.
        </div>
      </div>

      <div className="main">
        {/* <div className="main__ai-banner">
          <div>
            <svg
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style={{ minWidth: "14px" }}
            >
              <path
                d="M7 13C10.3137 13 13 10.3137 13 7C13 3.68629 10.3137 1 7 1C3.68629 1 1 3.68629 1 7C1 10.3137 3.68629 13 7 13Z"
                stroke="#667185"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M7 4.3335H7.00667V4.34016H7V4.3335Z"
                stroke="#667185"
                stroke-width="2.25"
                stroke-linejoin="round"
              />
              <path
                d="M7 7V9.66667"
                stroke="#667185"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>

            <div>
              Answer these questions to help Netzence AI better understand your
              facility and optimize its performance... <span>Click here</span>
            </div>
          </div>

          <svg
            width="12"
            height="13"
            viewBox="0 0 12 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ minWidth: "12px" }}
          >
            <path
              d="M3.37891 9.12142L6.00041 6.49992L8.62191 9.12142M8.62191 3.87842L5.99991 6.49992L3.37891 3.87842"
              stroke="#1A1A1A"
              stroke-width="0.75"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div> */}
        <div id="container" className="search_container">
          <Search />
          <div
            className={
              currentIndex === 4 ? "tag search_tag" : "tag search_tag no_tag"
            }
          >
            Shows KYC, Company details and your Profile
          </div>
        </div>
{
  comment?.data?.length >0 ? (
   <div className="flex justify-center mt-10">
  <div className="w-[1089px] max-w-[95%] bg-[#FEF6E7] border border-[#AD6F07] rounded-xl py-6 px-8 flex items-center justify-center text-center mb-3">
    <p className="text-[#DD900D] font-semibold text-[18px] leading-[27px] font-inter">
      Your KYC submission requires some updates.<Link to="/profile" className="underline"> Click here</Link>  to open your profile, then navigate to the KYC tab to review the corrections and reupload your documents.
    </p>
  </div>
</div>

  ) : (
    <div className="text-gray-500"></div>
  )
}




        <div className="carbon_card_group" id="card">
          <div className="card">
            <div className={currentIndex === 1 ? "tag" : "tag no_tag"}>
              Your cumulative amount of CO2 in stationary emissions
            </div>
            {totalEmision > 0 && (
              <div className="flex items-center space-x-2">
                <span className="title">Total CO2 Emissions</span>
                <div className="flex items-center space-x-2 relative group">
                  <svg
                    className="cursor-pointer"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14Z"
                      stroke="#98A2B3"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M8 5.33337H8.00667V5.34004H8V5.33337Z"
                      stroke="#98A2B3"
                      strokeWidth="2.25"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M8 8V10.6667"
                      stroke="#98A2B3"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>

                  {/* Tooltip */}
                  <div className="absolute top-full left-1/2 -translate-x-1/2 mt-2 w-64 bg-white text-gray-600 text-md rounded-lg shadow-lg p-3 opacity-0 group-hover:opacity-100 transition-opacity duration-200 z-10">
                    This shows the total amount of CO₂ emissions recorded for this facility over time.
                  </div>
                </div>

              </div>

            )}

            <div className="card__last-sync-date mb-2">
              Last Synced Date:{" "}
              <span>{`${moment(parseInt(lastSyncDate)).format(
                "Do MMM YYYY"
              )} ${moment(parseInt(lastSyncDate)).format("HH:mm:ss")}`}</span>
            </div>
            {/* <div className="total_emission">9245Kg</div> */}

            {generalLoading ? (
              <Skeleton width={130} height={130} circle={true} />
            ) : (
              <div className="emission_container">
                {totalEmision > 0 && (
                  <div className="total_emission">
                    {totalEmision > 0 && (
                      <div className="title">
                        {/* {`${totalEmision.toFixed(4)}tCO2`} */}
                        {totalEmision.toFixed(4) < 0.0001
                          ? `${(totalEmision).toFixed(7)}tCO2`
                          : `${totalEmision.toFixed(4)}tCO2`}
                      </div>

                    )}
                    <canvas id="doughnutChart"></canvas>
                  </div>
                )}

                {!totalEmision > 0 && (
                  <div className="doughnutChartx">
                    <svg
                      width="48"
                      height="48"
                      viewBox="0 0 48 48"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M29.1748 31.9901L32.0028 29.1631L44.0218 41.1821L41.1938 44.0091L29.1748 31.9901Z"
                        fill="#616161"
                      />
                      <path
                        d="M20 36C28.8366 36 36 28.8366 36 20C36 11.1634 28.8366 4 20 4C11.1634 4 4 11.1634 4 20C4 28.8366 11.1634 36 20 36Z"
                        fill="#616161"
                      />
                      <path
                        d="M32.4502 35.34L35.2772 32.512L43.9732 41.208L41.1452 44.036L32.4502 35.34Z"
                        fill="#37474F"
                      />
                      <path
                        d="M20 33C27.1797 33 33 27.1797 33 20C33 12.8203 27.1797 7 20 7C12.8203 7 7 12.8203 7 20C7 27.1797 12.8203 33 20 33Z"
                        fill="#00AED9"
                      />
                      <path
                        d="M26.8999 14.2C25.1999 12.2 22.6999 11 19.9999 11C17.2999 11 14.7999 12.2 13.0999 14.2C12.6999 14.6 12.7999 15.3 13.1999 15.6C13.5999 16 14.2999 15.9 14.5999 15.5C15.9999 13.9 17.8999 13 19.9999 13C22.0999 13 23.9999 13.9 25.3999 15.5C25.5999 15.7 25.8999 15.9 26.1999 15.9C26.3999 15.9 26.6999 15.8 26.7999 15.7C27.1999 15.3 27.1999 14.6 26.8999 14.2Z"
                        fill="#BBDEFB"
                      />
                    </svg>
                    <div className="doughnutChartx__title">
                      No CO2 emission yet
                    </div>
                  </div>
                )}

                {totalEmision > 0 && (
                  <div className="emission_label">
                    <div className="color"></div>
                    <div className="label_text">Stationary Emissions</div>
                  </div>
                )}
              </div>
            )}
          </div>
          <div className="card">
            <div
              className={
                currentIndex === 2 ? "tag offset_tag" : "tag offset_tag no_tag"
              }
            >
              Set a CO2 offset goal meet and view your total CO2 offset
            </div>
            <div className="title_group">
              <div className="title " > 
                {" "}
                {auth?.userInfo?.subscriptionPlan === "governance"
                  ? "NDCs-S Value"
                  : "Emission Reduction"}
              </div>
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                onClick={handleClick}
              >
                <path
                  d="M8 3.25C8.41421 3.25 8.75 2.91421 8.75 2.5C8.75 2.08579 8.41421 1.75 8 1.75C7.58579 1.75 7.25 2.08579 7.25 2.5C7.25 2.91421 7.58579 3.25 8 3.25Z"
                  stroke="#98A2B3"
                  stroke-width="2.25"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M8 8.75C8.41421 8.75 8.75 8.41421 8.75 8C8.75 7.58579 8.41421 7.25 8 7.25C7.58579 7.25 7.25 7.58579 7.25 8C7.25 8.41421 7.58579 8.75 8 8.75Z"
                  stroke="#98A2B3"
                  stroke-width="2.25"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M8 14.25C8.41421 14.25 8.75 13.9142 8.75 13.5C8.75 13.0858 8.41421 12.75 8 12.75C7.58579 12.75 7.25 13.0858 7.25 13.5C7.25 13.9142 7.58579 14.25 8 14.25Z"
                  stroke="#98A2B3"
                  stroke-width="2.25"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
            <Menu
              id="demo-positioned-menu"
              aria-labelledby="demo-positioned-button"
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              anchorOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
            >
              <div className="menu_container">
                <MenuItem
                  onClick={handleModalOpenTwo}
                  className=""
                  sx={{ width: "15rem" }}
                >
                  <svg
                    width="16"
                    height="16"
                    style={{ marginRight: "0.8rem" }}
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_2247_5665)">
                      <path
                        d="M13.637 2.36312L15.313 2.69812C15.403 2.71612 15.477 2.78212 15.503 2.87112C15.5161 2.91435 15.5173 2.96034 15.5064 3.00418C15.4955 3.04803 15.4729 3.08809 15.441 3.12012L14.068 4.49412C13.9037 4.65809 13.6811 4.75016 13.449 4.75012H12.31L9.45 7.61112C9.50456 7.81714 9.5146 8.03243 9.47943 8.24263C9.44427 8.45283 9.36472 8.65313 9.24607 8.83018C9.12743 9.00723 8.97242 9.15696 8.79137 9.2694C8.61032 9.38184 8.40739 9.45441 8.19609 9.48227C7.98479 9.51013 7.76999 9.49265 7.56598 9.43098C7.36197 9.36932 7.17344 9.26489 7.01296 9.12465C6.85248 8.98441 6.72372 8.81158 6.63527 8.61767C6.54682 8.42377 6.50071 8.21324 6.5 8.00012C6.50015 7.77001 6.55321 7.54302 6.65506 7.33668C6.75692 7.13034 6.90486 6.95019 7.08744 6.81013C7.27002 6.67008 7.48236 6.57388 7.70804 6.52897C7.93372 6.48406 8.16671 6.49164 8.389 6.55112L11.25 3.68912V2.55212C11.25 2.32012 11.342 2.09712 11.506 1.93312L12.88 0.559119C12.912 0.527248 12.9521 0.504652 12.9959 0.493735C13.0398 0.482818 13.0858 0.483988 13.129 0.497119C13.218 0.523119 13.284 0.597119 13.302 0.687119L13.637 2.36312Z"
                        fill="#667185"
                      />
                      <path
                        d="M2.00001 8.00004C2.00103 8.85801 2.18605 9.70577 2.54257 10.4861C2.8991 11.2665 3.41884 11.9614 4.06673 12.5238C4.71463 13.0862 5.47561 13.5032 6.29834 13.7465C7.12108 13.9898 7.98643 14.0539 8.83602 13.9343C9.68561 13.8148 10.4997 13.5144 11.2233 13.0535C11.947 12.5926 12.5633 11.9818 13.0309 11.2625C13.4984 10.5431 13.8062 9.7318 13.9336 8.88334C14.0609 8.03488 14.0048 7.16897 13.769 6.34404C13.7359 6.24767 13.7228 6.14556 13.7304 6.04394C13.738 5.94233 13.7662 5.84332 13.8133 5.75296C13.8604 5.66259 13.9254 5.58276 14.0044 5.51832C14.0833 5.45388 14.1745 5.40618 14.2725 5.37812C14.3705 5.35006 14.4731 5.34223 14.5742 5.35511C14.6753 5.36799 14.7727 5.40131 14.8605 5.45304C14.9483 5.50477 15.0246 5.57382 15.0849 5.656C15.1452 5.73818 15.1881 5.83176 15.211 5.93104C15.6675 7.52857 15.5808 9.23245 14.9645 10.7754C14.3481 12.3183 13.237 13.613 11.8054 14.4563C10.3739 15.2995 8.70285 15.6437 7.05455 15.4348C5.40626 15.2259 3.87395 14.4758 2.69801 13.302C1.52335 12.1264 0.772381 10.5939 0.56301 8.94526C0.353638 7.29658 0.697719 5.62506 1.54123 4.19312C2.38474 2.76118 3.67991 1.64991 5.2234 1.03378C6.76689 0.417663 8.47129 0.331577 10.069 0.789044C10.2592 0.844656 10.4197 0.973312 10.5154 1.1469C10.6111 1.32048 10.6342 1.52488 10.5796 1.71542C10.525 1.90596 10.3972 2.06716 10.2242 2.16377C10.0511 2.26039 9.84684 2.28458 9.65601 2.23104C8.76259 1.97471 7.82184 1.92941 6.90792 2.09871C5.99401 2.26801 5.13191 2.64729 4.3896 3.20664C3.64728 3.766 3.04505 4.49013 2.63037 5.32196C2.21568 6.15379 1.99989 7.07058 2.00001 8.00004Z"
                        fill="#667185"
                      />
                      <path
                        d="M4.99999 7.99999C5.00005 8.54658 5.14934 9.08278 5.43175 9.55075C5.71417 10.0187 6.11899 10.4007 6.60256 10.6555C7.08613 10.9103 7.63008 11.0283 8.17576 10.9966C8.72143 10.965 9.24811 10.785 9.69899 10.476C10.1498 10.1662 10.5073 9.73912 10.7329 9.24085C10.9585 8.74258 11.0436 8.19212 10.979 7.64899C10.9615 7.51719 10.9795 7.38311 11.031 7.26056C11.0826 7.13802 11.1659 7.03143 11.2723 6.95177C11.3788 6.87211 11.5045 6.82226 11.6367 6.80736C11.7688 6.79246 11.9025 6.81304 12.024 6.86699C12.1455 6.92023 12.2507 7.00474 12.3289 7.1119C12.407 7.21906 12.4554 7.34504 12.469 7.47699C12.5776 8.40509 12.3947 9.34399 11.9455 10.1634C11.4963 10.9828 10.8032 11.642 9.96233 12.0496C9.12147 12.4572 8.17458 12.5929 7.25308 12.4379C6.33159 12.2829 5.4812 11.8449 4.81995 11.1846C4.1587 10.5244 3.71939 9.67468 3.56299 8.75342C3.40659 7.83216 3.54087 6.88507 3.94718 6.04358C4.35348 5.2021 5.01167 4.50798 5.83038 4.05755C6.6491 3.60712 7.58773 3.42274 8.51599 3.52999C8.61538 3.53921 8.71194 3.56818 8.79999 3.6152C8.88805 3.66222 8.96583 3.72635 9.02878 3.80382C9.09172 3.88129 9.13857 3.97055 9.16658 4.06636C9.19458 4.16218 9.20318 4.26262 9.19186 4.3618C9.18055 4.46097 9.14955 4.5569 9.10068 4.64394C9.05181 4.73098 8.98606 4.80739 8.90728 4.86869C8.8285 4.93 8.73827 4.97495 8.64189 5.00093C8.54551 5.02691 8.44491 5.03339 8.34599 5.01999C7.92565 4.97118 7.49973 5.01185 7.09623 5.13933C6.69272 5.26681 6.32075 5.47822 6.00474 5.75966C5.68873 6.0411 5.43584 6.38621 5.26267 6.77233C5.08951 7.15844 4.99999 7.57682 4.99999 7.99999Z"
                        fill="#667185"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_2247_5665">
                        <rect width="16" height="16" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>

                  <div style={{ fontSize: "12px" }}>Set New Goal</div>
                </MenuItem>

                <MenuItem onClick={handleModalOpenTwo} className="">
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    style={{ marginRight: "0.8rem" }}
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M5.75 3V1.5H10.25V3H5.75ZM4.25 3V1C4.25 0.734784 4.35536 0.48043 4.54289 0.292893C4.73043 0.105357 4.98478 0 5.25 0L10.75 0C11.0152 0 11.2696 0.105357 11.4571 0.292893C11.6446 0.48043 11.75 0.734784 11.75 1V3H14.25C14.4489 3 14.6397 3.07902 14.7803 3.21967C14.921 3.36032 15 3.55109 15 3.75C15 3.94891 14.921 4.13968 14.7803 4.28033C14.6397 4.42098 14.4489 4.5 14.25 4.5H13.885L13.142 14.153C13.1034 14.6554 12.8767 15.1248 12.507 15.4673C12.1373 15.8097 11.6519 16 11.148 16H4.852C4.34808 16 3.86274 15.8097 3.49304 15.4673C3.12335 15.1248 2.89655 14.6554 2.858 14.153L2.115 4.5H1.75C1.55109 4.5 1.36032 4.42098 1.21967 4.28033C1.07902 4.13968 1 3.94891 1 3.75C1 3.55109 1.07902 3.36032 1.21967 3.21967C1.36032 3.07902 1.55109 3 1.75 3H4.25ZM3.62 4.5H12.38L11.646 14.038C11.6364 14.1636 11.5798 14.2809 11.4875 14.3666C11.3952 14.4522 11.2739 14.4999 11.148 14.5H4.852C4.72607 14.4999 4.60482 14.4522 4.5125 14.3666C4.42017 14.2809 4.36357 14.1636 4.354 14.038L3.62 4.5Z"
                      fill="#667185"
                    />
                  </svg>

                  <div style={{ fontSize: "12px" }}>Remove Goal</div>
                </MenuItem>
                {/* <MenuItem onClick={() => setFabData(true)} className="">
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    style={{ marginRight: "6px" }}
                  >
                    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                    <g
                      id="SVGRepo_tracerCarrier"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></g>
                    <g id="SVGRepo_iconCarrier">
                      {" "}
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M12 8.25C9.92894 8.25 8.25 9.92893 8.25 12C8.25 14.0711 9.92894 15.75 12 15.75C14.0711 15.75 15.75 14.0711 15.75 12C15.75 9.92893 14.0711 8.25 12 8.25ZM9.75 12C9.75 10.7574 10.7574 9.75 12 9.75C13.2426 9.75 14.25 10.7574 14.25 12C14.25 13.2426 13.2426 14.25 12 14.25C10.7574 14.25 9.75 13.2426 9.75 12Z"
                        fill="#667185"
                      ></path>{" "}
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M11.9747 1.25C11.5303 1.24999 11.1592 1.24999 10.8546 1.27077C10.5375 1.29241 10.238 1.33905 9.94761 1.45933C9.27379 1.73844 8.73843 2.27379 8.45932 2.94762C8.31402 3.29842 8.27467 3.66812 8.25964 4.06996C8.24756 4.39299 8.08454 4.66251 7.84395 4.80141C7.60337 4.94031 7.28845 4.94673 7.00266 4.79568C6.64714 4.60777 6.30729 4.45699 5.93083 4.40743C5.20773 4.31223 4.47642 4.50819 3.89779 4.95219C3.64843 5.14353 3.45827 5.3796 3.28099 5.6434C3.11068 5.89681 2.92517 6.21815 2.70294 6.60307L2.67769 6.64681C2.45545 7.03172 2.26993 7.35304 2.13562 7.62723C1.99581 7.91267 1.88644 8.19539 1.84541 8.50701C1.75021 9.23012 1.94617 9.96142 2.39016 10.5401C2.62128 10.8412 2.92173 11.0602 3.26217 11.2741C3.53595 11.4461 3.68788 11.7221 3.68786 12C3.68785 12.2778 3.53592 12.5538 3.26217 12.7258C2.92169 12.9397 2.62121 13.1587 2.39007 13.4599C1.94607 14.0385 1.75012 14.7698 1.84531 15.4929C1.88634 15.8045 1.99571 16.0873 2.13552 16.3727C2.26983 16.6469 2.45535 16.9682 2.67758 17.3531L2.70284 17.3969C2.92507 17.7818 3.11058 18.1031 3.28089 18.3565C3.45817 18.6203 3.64833 18.8564 3.89769 19.0477C4.47632 19.4917 5.20763 19.6877 5.93073 19.5925C6.30717 19.5429 6.647 19.3922 7.0025 19.2043C7.28833 19.0532 7.60329 19.0596 7.8439 19.1986C8.08452 19.3375 8.24756 19.607 8.25964 19.9301C8.27467 20.3319 8.31403 20.7016 8.45932 21.0524C8.73843 21.7262 9.27379 22.2616 9.94761 22.5407C10.238 22.661 10.5375 22.7076 10.8546 22.7292C11.1592 22.75 11.5303 22.75 11.9747 22.75H12.0252C12.4697 22.75 12.8407 22.75 13.1454 22.7292C13.4625 22.7076 13.762 22.661 14.0524 22.5407C14.7262 22.2616 15.2616 21.7262 15.5407 21.0524C15.686 20.7016 15.7253 20.3319 15.7403 19.93C15.7524 19.607 15.9154 19.3375 16.156 19.1985C16.3966 19.0596 16.7116 19.0532 16.9974 19.2042C17.3529 19.3921 17.6927 19.5429 18.0692 19.5924C18.7923 19.6876 19.5236 19.4917 20.1022 19.0477C20.3516 18.8563 20.5417 18.6203 20.719 18.3565C20.8893 18.1031 21.0748 17.7818 21.297 17.3969L21.3223 17.3531C21.5445 16.9682 21.7301 16.6468 21.8644 16.3726C22.0042 16.0872 22.1135 15.8045 22.1546 15.4929C22.2498 14.7697 22.0538 14.0384 21.6098 13.4598C21.3787 13.1586 21.0782 12.9397 20.7378 12.7258C20.464 12.5538 20.3121 12.2778 20.3121 11.9999C20.3121 11.7221 20.464 11.4462 20.7377 11.2742C21.0783 11.0603 21.3788 10.8414 21.6099 10.5401C22.0539 9.96149 22.2499 9.23019 22.1547 8.50708C22.1136 8.19546 22.0043 7.91274 21.8645 7.6273C21.7302 7.35313 21.5447 7.03183 21.3224 6.64695L21.2972 6.60318C21.0749 6.21825 20.8894 5.89688 20.7191 5.64347C20.5418 5.37967 20.3517 5.1436 20.1023 4.95225C19.5237 4.50826 18.7924 4.3123 18.0692 4.4075C17.6928 4.45706 17.353 4.60782 16.9975 4.79572C16.7117 4.94679 16.3967 4.94036 16.1561 4.80144C15.9155 4.66253 15.7524 4.39297 15.7403 4.06991C15.7253 3.66808 15.686 3.2984 15.5407 2.94762C15.2616 2.27379 14.7262 1.73844 14.0524 1.45933C13.762 1.33905 13.4625 1.29241 13.1454 1.27077C12.8407 1.24999 12.4697 1.24999 12.0252 1.25H11.9747ZM10.5216 2.84515C10.5988 2.81319 10.716 2.78372 10.9567 2.76729C11.2042 2.75041 11.5238 2.75 12 2.75C12.4762 2.75 12.7958 2.75041 13.0432 2.76729C13.284 2.78372 13.4012 2.81319 13.4783 2.84515C13.7846 2.97202 14.028 3.21536 14.1548 3.52165C14.1949 3.61826 14.228 3.76887 14.2414 4.12597C14.271 4.91835 14.68 5.68129 15.4061 6.10048C16.1321 6.51968 16.9974 6.4924 17.6984 6.12188C18.0143 5.9549 18.1614 5.90832 18.265 5.89467C18.5937 5.8514 18.9261 5.94047 19.1891 6.14228C19.2554 6.19312 19.3395 6.27989 19.4741 6.48016C19.6125 6.68603 19.7726 6.9626 20.0107 7.375C20.2488 7.78741 20.4083 8.06438 20.5174 8.28713C20.6235 8.50382 20.6566 8.62007 20.6675 8.70287C20.7108 9.03155 20.6217 9.36397 20.4199 9.62698C20.3562 9.70995 20.2424 9.81399 19.9397 10.0041C19.2684 10.426 18.8122 11.1616 18.8121 11.9999C18.8121 12.8383 19.2683 13.574 19.9397 13.9959C20.2423 14.186 20.3561 14.29 20.4198 14.373C20.6216 14.636 20.7107 14.9684 20.6674 15.2971C20.6565 15.3799 20.6234 15.4961 20.5173 15.7128C20.4082 15.9355 20.2487 16.2125 20.0106 16.6249C19.7725 17.0373 19.6124 17.3139 19.474 17.5198C19.3394 17.72 19.2553 17.8068 19.189 17.8576C18.926 18.0595 18.5936 18.1485 18.2649 18.1053C18.1613 18.0916 18.0142 18.045 17.6983 17.8781C16.9973 17.5075 16.132 17.4803 15.4059 17.8995C14.68 18.3187 14.271 19.0816 14.2414 19.874C14.228 20.2311 14.1949 20.3817 14.1548 20.4784C14.028 20.7846 13.7846 21.028 13.4783 21.1549C13.4012 21.1868 13.284 21.2163 13.0432 21.2327C12.7958 21.2496 12.4762 21.25 12 21.25C11.5238 21.25 11.2042 21.2496 10.9567 21.2327C10.716 21.2163 10.5988 21.1868 10.5216 21.1549C10.2154 21.028 9.97201 20.7846 9.84514 20.4784C9.80512 20.3817 9.77195 20.2311 9.75859 19.874C9.72896 19.0817 9.31997 18.3187 8.5939 17.8995C7.86784 17.4803 7.00262 17.5076 6.30158 17.8781C5.98565 18.0451 5.83863 18.0917 5.73495 18.1053C5.40626 18.1486 5.07385 18.0595 4.81084 17.8577C4.74458 17.8069 4.66045 17.7201 4.52586 17.5198C4.38751 17.314 4.22736 17.0374 3.98926 16.625C3.75115 16.2126 3.59171 15.9356 3.4826 15.7129C3.37646 15.4962 3.34338 15.3799 3.33248 15.2971C3.28921 14.9684 3.37828 14.636 3.5801 14.373C3.64376 14.2901 3.75761 14.186 4.0602 13.9959C4.73158 13.5741 5.18782 12.8384 5.18786 12.0001C5.18791 11.1616 4.73165 10.4259 4.06021 10.004C3.75769 9.81389 3.64385 9.70987 3.58019 9.62691C3.37838 9.3639 3.28931 9.03149 3.33258 8.7028C3.34348 8.62001 3.37656 8.50375 3.4827 8.28707C3.59181 8.06431 3.75125 7.78734 3.98935 7.37493C4.22746 6.96253 4.3876 6.68596 4.52596 6.48009C4.66055 6.27983 4.74468 6.19305 4.81093 6.14222C5.07395 5.9404 5.40636 5.85133 5.73504 5.8946C5.83873 5.90825 5.98576 5.95483 6.30173 6.12184C7.00273 6.49235 7.86791 6.51962 8.59394 6.10045C9.31998 5.68128 9.72896 4.91837 9.75859 4.12602C9.77195 3.76889 9.80512 3.61827 9.84514 3.52165C9.97201 3.21536 10.2154 2.97202 10.5216 2.84515Z"
                        fill="#667185"
                      ></path>{" "}
                    </g>
                  </svg>

                  <div style={{ fontSize: "12px" }}>Get fabricated data</div>
                </MenuItem> */}
              </div>
            </Menu>

            {generalLoading ? (
              <Skeleton height={120} borderRadius={4} />
            ) : ( 
              <div className="offset_meter ">
                <div
                  className={offset > 0 ? "meter_active" : "meter_inactive"}
                  style={{
                    width: 41.14,
                    height: 5.31,
                    left: 0,
                    top: 71.69,
                    position: "absolute",
                  }}
                ></div>
                <div
                  className={
                    offset > 0 && offset >= offsetGoal
                      ? "meter_active"
                      : "meter_inactive"
                  }
                  style={{
                    width: 41.14,
                    height: 5.31,
                    left: 112.14,
                    top: 72.12,
                    position: "absolute",
                  }}
                ></div>
                <div
                  className={
                    offset > 0 && offset >= (offsetGoal / 13) * 2
                      ? "meter_active"
                      : "meter_inactive"
                  }
                  style={{
                    width: 41.23,
                    height: 5.3,
                    left: 2.62,
                    top: 54.43,
                    position: "absolute",
                    transform: "rotate(15.47deg)",
                    transformOrigin: "0 0",
                  }}
                ></div>
                <div
                  className={
                    offset > 0 && offset >= (offsetGoal / 13) * 12
                      ? "meter_active"
                      : "meter_inactive"
                  }
                  style={{
                    width: 41.23,
                    height: 5.3,
                    left: 109.57,
                    top: 65.86,
                    position: "absolute",
                    transform: "rotate(-15.47deg)",
                    transformOrigin: "0 0",
                  }}
                ></div>
                <div
                  className={
                    offset > 0 && offset >= (offsetGoal / 13) * 3
                      ? "meter_active"
                      : "meter_inactive"
                  }
                  style={{
                    width: 41.48,
                    height: 5.27,
                    left: 11.57,
                    top: 37.17,
                    position: "absolute",
                    transform: "rotate(30.80deg)",
                    transformOrigin: "0 0",
                  }}
                ></div>
                <div
                  className={
                    offset > 0 && offset >= (offsetGoal / 13) * 11
                      ? "meter_active"
                      : "meter_inactive"
                  }
                  style={{
                    width: 41.48,
                    height: 5.27,
                    left: 101.86,
                    top: 58.84,
                    position: "absolute",
                    transform: "rotate(-30.80deg)",
                    transformOrigin: "0 0",
                  }}
                ></div>
                <div
                  className={
                    offset > 0 && offset >= (offsetGoal / 13) * 5
                      ? "meter_active"
                      : "meter_inactive"
                  }
                  style={{
                    width: 42.15,
                    height: 5.19,
                    left: 39.17,
                    top: 9.29,
                    position: "absolute",
                    transform: "rotate(60.79deg)",
                    transformOrigin: "0 0",
                  }}
                ></div>
                <div
                  className={
                    offset > 0 && offset >= (offsetGoal / 13) * 9
                      ? "meter_active"
                      : "meter_inactive"
                  }
                  style={{
                    width: 42.15,
                    height: 5.19,
                    left: 91.29,
                    top: 47.41,
                    position: "absolute",
                    transform: "rotate(-60.79deg)",
                    transformOrigin: "0 0",
                  }}
                ></div>
                <div
                  className={
                    offset > 0 && offset >= (offsetGoal / 13) * 4
                      ? "meter_active"
                      : "meter_inactive"
                  }
                  style={{
                    width: 41.82,
                    height: 5.23,
                    left: 22.92,
                    top: 21.24,
                    position: "absolute",
                    transform: "rotate(45.92deg)",
                    transformOrigin: "0 0",
                  }}
                ></div>
                <div
                  className={
                    offset > 0 && offset >= (offsetGoal / 13) * 10
                      ? "meter_active"
                      : "meter_inactive"
                  }
                  style={{
                    width: 41.82,
                    height: 5.23,
                    left: 98,
                    top: 53.04,
                    position: "absolute",
                    transform: "rotate(-45.92deg)",
                    transformOrigin: "0 0",
                  }}
                ></div>
                <div
                  className={
                    offset > 0 && offset >= (offsetGoal / 13) * 6
                      ? "meter_active"
                      : "meter_inactive"
                  }
                  style={{
                    width: 42.39,
                    height: 5.15,
                    left: 57.68,
                    top: 1.33,
                    position: "absolute",
                    transform: "rotate(75.45deg)",
                    transformOrigin: "0 0",
                  }}
                ></div>
                <div
                  className={
                    offset > 0 && offset >= (offsetGoal / 13) * 8
                      ? "meter_active"
                      : "meter_inactive"
                  }
                  style={{
                    width: 42.39,
                    height: 5.15,
                    left: 82.29,
                    top: 42.36,
                    position: "absolute",
                    transform: "rotate(-75.45deg)",
                    transformOrigin: "0 0",
                  }}
                ></div>
                <div
                  className={
                    offset > 0 && offset >= (offsetGoal / 13) * 7
                      ? "meter_active"
                      : "meter_inactive"
                  }
                  style={{
                    width: 42.48,
                    height: 5.14,
                    left: 78.43,
                    top: 0,
                    position: "absolute",
                    transform: "rotate(90deg)",
                    transformOrigin: "0 0",
                  }}
                ></div>
              </div>
            )}

            {!generalLoading && (
              <div className="metric">
                <div className={offset > 0 && "active"}>
                  <div className="mt-5 text-[#2C9963] ">Total Offset</div>

                  <div>
                    
                    <div className={offset > 0 ? "span active" : "span"}> {offset?.toFixed(4)}  t  CO2
                    </div>
                  </div>
                </div>
                <div>
                  <div className="mt-5">Your Goal</div>

                  <div>
                    <div className="span">  {offsetGoal} t CO2</div>
                  </div>
                </div>
              </div>
            )}

            {modalOpenTwo && (
              <form className="goal_modal" onSubmit={handleSetGoal}>
                <div className="goal_flex">
                  <div className="title">Set New Goal</div>
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    onClick={() => setModalOpenTwo(false)}
                  >
                    <path
                      d="M6.758 17.2431L12.001 12.0001L17.244 17.2431M17.244 6.75708L12 12.0001L6.758 6.75708"
                      stroke="#D42620"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <label htmlFor="">Input New Offset Goal</label>
                <div className="goal_modal__input">
                  <input
                    className="goal_input"
                    type="number"
                    placeholder="Set offset goals"
                    value={newGoal}
                    onChange={(e) => setNewGoal(e.target.value)}
                  />
                  <div>tCO2</div>
                </div>

                {/* <PaystackButton {...componentProps} /> */}
                <button className="goal_button" type="submit">
                  {loading ? "Loading..." : "Done"}
                </button>
              </form>
            )}
          </div>
          <div className="card">
            {offset > 0 && (
              <div
                className={
                  currentIndex === 3
                    ? "tag credit_tag"
                    : "no_tag tag credit_tag"
                }
              >
                Total CCRT received
              </div>


            )}

            {offset > 0 && <div className="title credit">Total CCRT</div>}
            {offset > 0 && <div className="subtitle">CCRT overview</div>}
            {generalLoading ? (
              <Skeleton height={20} borderRadius={4} />
            ) : (
              offset > 0 && (
                <div className="offset_view">
                  <div className="offset_view_carbon">
                    {/* {offset.toFixed(4) < 0.0001
                      ? `${(offset * 1000).toFixed(4)}kgCO2`
                      : `${offset.toFixed(4)}tCO2`} */}
                    {`${offset.toFixed(4)} tCO2 `}
                  </div>
                  <div className="offset_view_credit">
                    {Number(ccrtValue).toFixed(4)}CCRT
                  </div>
                </div>
              )

            )}

            {/* Wrap the legend in the same conditional */}
            {offset > 0 && (
              <div className="space-y-4 mt-8">
                {/* Total CCRT Issued */}
                <div className="flex items-center space-x-2">
                  <span className="w-6 h-6 bg-[#F0F2F5] rounded-md"></span>
                  <span className="text-gray-500 text-md font-medium fontSize-[10px]">
                    Total Offset / Emission Reduction
                  </span>
                </div>

                {/* Total Offset / Emission Reduction */}
                <div className="flex items-center space-x-2">
                  <span className="w-6 h-6 bg-[#2C9963] rounded-md"></span>
                  <span className="text-gray-500 text-md font-medium">
                    Total CCRT Issued
                  </span>
                </div>
              </div>
            )}

            {offset <= 0 && (
              <div className="doughnutChartx">
                <svg
                  width="48"
                  height="48"
                  viewBox="0 0 48 48"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M29.1748 31.9901L32.0028 29.1631L44.0218 41.1821L41.1938 44.0091L29.1748 31.9901Z"
                    fill="#616161"
                  />
                  <path
                    d="M20 36C28.8366 36 36 28.8366 36 20C36 11.1634 28.8366 4 20 4C11.1634 4 4 11.1634 4 20C4 28.8366 11.1634 36 20 36Z"
                    fill="#616161"
                  />
                  <path
                    d="M32.4502 35.34L35.2772 32.512L43.9732 41.208L41.1452 44.036L32.4502 35.34Z"
                    fill="#37474F"
                  />
                  <path
                    d="M20 33C27.1797 33 33 27.1797 33 20C33 12.8203 27.1797 7 20 7C12.8203 7 7 12.8203 7 20C7 27.1797 12.8203 33 20 33Z"
                    fill="#00AED9"
                  />
                  <path
                    d="M26.8999 14.2C25.1999 12.2 22.6999 11 19.9999 11C17.2999 11 14.7999 12.2 13.0999 14.2C12.6999 14.6 12.7999 15.3 13.1999 15.6C13.5999 16 14.2999 15.9 14.5999 15.5C15.9999 13.9 17.8999 13 19.9999 13C22.0999 13 23.9999 13.9 25.3999 15.5C25.5999 15.7 25.8999 15.9 26.1999 15.9C26.3999 15.9 26.6999 15.8 26.7999 15.7C27.1999 15.3 27.1999 14.6 26.8999 14.2Z"
                    fill="#BBDEFB"
                  />
                </svg>
                <div className="doughnutChartx__title">
                  You’re yet to earn CCRT
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="main__emission-group">
          <div>
            <div className="activity_card_group">
              <div
                className="trigger pointer"
                onMouseEnter={() => setCardVisible("chart")}
                onMouseLeave={() => setCardVisible("")}
              ></div>
              <div className="card1">
                <div className={currentIndex === 5 ? "tag" : "tag no_tag"}>
                  CO2 tracked graph in the last 7 days
                </div>
                <div
                  className={
                    cardVisible === "chart"
                      ? "tag reoccuing_tag reoccuing_tag_chart"
                      : "tag no_tag reoccuing_tag reoccuing_tag_chart"
                  }
                >
                  Co2 tracked from the facility within the last 7days
                </div>
                <div id="myChartg" ref={chartRef}></div>
                {weeklyEmission?.length < 1 && (
                  <div className="line-chart-empty-state">
                    <svg
                      width="48"
                      height="48"
                      viewBox="0 0 48 48"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M29.1748 31.9901L32.0028 29.1631L44.0218 41.1821L41.1938 44.0091L29.1748 31.9901Z"
                        fill="#616161"
                      />
                      <path
                        d="M20 36C28.8366 36 36 28.8366 36 20C36 11.1634 28.8366 4 20 4C11.1634 4 4 11.1634 4 20C4 28.8366 11.1634 36 20 36Z"
                        fill="#616161"
                      />
                      <path
                        d="M32.4502 35.34L35.2772 32.512L43.9732 41.208L41.1452 44.036L32.4502 35.34Z"
                        fill="#37474F"
                      />
                      <path
                        d="M20 33C27.1797 33 33 27.1797 33 20C33 12.8203 27.1797 7 20 7C12.8203 7 7 12.8203 7 20C7 27.1797 12.8203 33 20 33Z"
                        fill="#00AED9"
                      />
                      <path
                        d="M26.8999 14.2C25.1999 12.2 22.6999 11 19.9999 11C17.2999 11 14.7999 12.2 13.0999 14.2C12.6999 14.6 12.7999 15.3 13.1999 15.6C13.5999 16 14.2999 15.9 14.5999 15.5C15.9999 13.9 17.8999 13 19.9999 13C22.0999 13 23.9999 13.9 25.3999 15.5C25.5999 15.7 25.8999 15.9 26.1999 15.9C26.3999 15.9 26.6999 15.8 26.7999 15.7C27.1999 15.3 27.1999 14.6 26.8999 14.2Z"
                        fill="#BBDEFB"
                      />
                    </svg>
                    <div className="doughnutChartx__title">
                      Nothing to see here
                    </div>
                  </div>
                )}
              </div>
              {/* <div className="card2">
            <div className="title_group">
              <div>Latest Activity</div>
              <div>SEE ALL</div>
            </div>
          </div> */}
            </div>
            <div className="management_card_group management_card_group-hidden-mobile">
              <div className="card1">
                <div className="title_group">
                  <div>
                    Carbon Emission Management{" "}
                    <svg
                      className="pointer"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      onMouseEnter={() => setCardVisible("table")}
                      onMouseLeave={() => setCardVisible("")}
                    >
                      <path
                        d="M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14Z"
                        stroke="#98A2B3"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M8 5.33337H8.00667V5.34004H8V5.33337Z"
                        stroke="#98A2B3"
                        stroke-width="2.25"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M8 8V10.6667"
                        stroke="#98A2B3"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </div>
                  <div className="title_group__flex">
                    <div
                      className="ndclist-table__header__select pointer"
                      onClick={handleNdcCalendarClick}
                    >
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M5.60039 8.4C5.81256 8.4 6.01605 8.31571 6.16608 8.16569C6.31611 8.01566 6.40039 7.81217 6.40039 7.6C6.40039 7.38783 6.31611 7.18434 6.16608 7.03432C6.01605 6.88429 5.81256 6.8 5.60039 6.8C5.38822 6.8 5.18473 6.88429 5.03471 7.03432C4.88468 7.18434 4.80039 7.38783 4.80039 7.6C4.80039 7.81217 4.88468 8.01566 5.03471 8.16569C5.18473 8.31571 5.38822 8.4 5.60039 8.4ZM6.40039 10C6.40039 10.2122 6.31611 10.4157 6.16608 10.5657C6.01605 10.7157 5.81256 10.8 5.60039 10.8C5.38822 10.8 5.18473 10.7157 5.03471 10.5657C4.88468 10.4157 4.80039 10.2122 4.80039 10C4.80039 9.78783 4.88468 9.58434 5.03471 9.43432C5.18473 9.28429 5.38822 9.2 5.60039 9.2C5.81256 9.2 6.01605 9.28429 6.16608 9.43432C6.31611 9.58434 6.40039 9.78783 6.40039 10ZM8.00039 8.4C8.21256 8.4 8.41605 8.31571 8.56608 8.16569C8.71611 8.01566 8.80039 7.81217 8.80039 7.6C8.80039 7.38783 8.71611 7.18434 8.56608 7.03432C8.41605 6.88429 8.21256 6.8 8.00039 6.8C7.78822 6.8 7.58473 6.88429 7.43471 7.03432C7.28468 7.18434 7.20039 7.38783 7.20039 7.6C7.20039 7.81217 7.28468 8.01566 7.43471 8.16569C7.58473 8.31571 7.78822 8.4 8.00039 8.4ZM8.80039 10C8.80039 10.2122 8.71611 10.4157 8.56608 10.5657C8.41605 10.7157 8.21256 10.8 8.00039 10.8C7.78822 10.8 7.58473 10.7157 7.43471 10.5657C7.28468 10.4157 7.20039 10.2122 7.20039 10C7.20039 9.78783 7.28468 9.58434 7.43471 9.43432C7.58473 9.28429 7.78822 9.2 8.00039 9.2C8.21256 9.2 8.41605 9.28429 8.56608 9.43432C8.71611 9.58434 8.80039 9.78783 8.80039 10ZM10.4004 8.4C10.6126 8.4 10.816 8.31571 10.9661 8.16569C11.1161 8.01566 11.2004 7.81217 11.2004 7.6C11.2004 7.38783 11.1161 7.18434 10.9661 7.03432C10.816 6.88429 10.6126 6.8 10.4004 6.8C10.1882 6.8 9.98474 6.88429 9.83471 7.03432C9.68468 7.18434 9.60039 7.38783 9.60039 7.6C9.60039 7.81217 9.68468 8.01566 9.83471 8.16569C9.98474 8.31571 10.1882 8.4 10.4004 8.4ZM13.6004 4C13.6004 3.46957 13.3897 2.96086 13.0146 2.58579C12.6395 2.21071 12.1308 2 11.6004 2H4.40039C3.86996 2 3.36125 2.21071 2.98618 2.58579C2.6111 2.96086 2.40039 3.46957 2.40039 4V11.2C2.40039 11.7304 2.6111 12.2391 2.98618 12.6142C3.36125 12.9893 3.86996 13.2 4.40039 13.2H11.6004C12.1308 13.2 12.6395 12.9893 13.0146 12.6142C13.3897 12.2391 13.6004 11.7304 13.6004 11.2V4ZM3.20039 5.2H12.8004V11.2C12.8004 11.5183 12.674 11.8235 12.4489 12.0485C12.2239 12.2736 11.9187 12.4 11.6004 12.4H4.40039C4.08213 12.4 3.77691 12.2736 3.55186 12.0485C3.32682 11.8235 3.20039 11.5183 3.20039 11.2V5.2ZM4.40039 2.8H11.6004C11.9187 2.8 12.2239 2.92643 12.4489 3.15147C12.674 3.37652 12.8004 3.68174 12.8004 4V4.4H3.20039V4C3.20039 3.68174 3.32682 3.37652 3.55186 3.15147C3.77691 2.92643 4.08213 2.8 4.40039 2.8Z"
                          fill="#747474"
                        />
                      </svg>

                      <div>
                        {firstDate} - {lastDate}
                      </div>
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M4.66732 6.66667L8.00065 10L11.334 6.66667"
                          stroke="#747474"
                          stroke-width="1.33333"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </div>

                    {auth?.userInfo?.subscriptionPlan === "business" && (

                      <button
                        className="title_group__flex__button"
                        onClick={() =>
                          setOpenDownloadReport(!openDownloadReport)
                        }
                      >
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M1.33264 9.66687C1.33264 10.0608 1.41024 10.4509 1.561 10.8149C1.71177 11.1789 1.93275 11.5096 2.21132 11.7882C2.77393 12.3508 3.53699 12.6669 4.33264 12.6669H12.3326C12.9233 12.6679 13.4924 12.445 13.9251 12.0429C14.3578 11.6409 14.6219 11.0897 14.6642 10.5006C14.7065 9.91149 14.5238 9.32825 14.1529 8.86854C13.7821 8.40882 13.2507 8.10686 12.666 8.02354C12.6725 6.88938 12.2657 5.79167 11.5218 4.9356C10.7778 4.07953 9.74751 3.5237 8.62352 3.37202C7.49954 3.22033 6.35878 3.48316 5.41449 4.11139C4.4702 4.73962 3.78701 5.69023 3.49264 6.78554C2.86939 6.96755 2.32196 7.34676 1.93251 7.86627C1.54305 8.38579 1.33257 9.01759 1.33264 9.66687Z"
                            stroke="white"
                            stroke-width="1.5"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M6.66602 8.66667L7.99935 10M7.99935 10L9.33268 8.66667M7.99935 10V6"
                            stroke="white"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        Download Report
                      </button>
                    )}
                  </div>

                  {/* <form className="date_group">
                    <div>
                      <div>From</div>
                      <input
                        type="date"
                        value={from}
                        onChange={handleFromChange}
                      />
                      {inRangeLoading && <div>Loading...</div>}
                    </div>
                    <div>
                      <div>To</div>
                      <input type="date" value={to} onChange={handleToChange} />
                    </div>
                  </form> */}
                </div>

                <div className="emission_table" id="table">
                  <div
                    className={
                      currentIndex === 6
                        ? "tag table_tag"
                        : "tag table_tag no_tag"
                    }
                  >
                    This table shows CO2 tracked, calculated & offset at a given
                    period of time in real numbers{" "}
                  </div>

                  <div
                    className={
                      cardVisible === "table"
                        ? "tag table_tag reoccuing_tag"
                        : "tag table_tag reoccuing_tag no_tag"
                    }
                  >
                    Your daily carbon emission and reduction table
                  </div>
                  {!generalLoading && emissionOffsetData?.length > 0 && (
                    <div className="table_header_container">
                      <div className="table_header first">Time period</div>
                      <div className="table_header">Emission tracked</div>
                      <div className="table_header">Baseline</div>
                      <div className="table_header last">
                        {auth?.userInfo?.subscriptionPlan === "governance"
                          ? "NDCs-S Value"
                          : "Emission Reduction"}
                      </div>
                    </div>
                  )}
                  {!generalLoading && emissionOffsetData?.length < 1 && (
                    <div className="table_header_container-empty"></div>
                  )}
                  {generalLoading ? (
                    <>
                      <Skeleton
                        height={40}
                        borderRadius={4}
                        count={5}
                        style={{ marginTop: "24px" }}
                      />
                    </>
                  ) : (
                    <>
                      {emissionOffsetData?.length > 0 &&
                        emissionOffsetData?.map((item) => (
                          <>
                            <div className="table_body_container">
                              <div>
                                {formatDate(item?.createdAt)}
                              </div>
                              <div>
                                {/* {Number(item?.totalGhgEmission).toFixed(4) <
                                 0.0001
                                 ? `${(
                                   Number(item?.totalGhgEmission) * 1000
                                 ).toFixed(4)}kgCO2`
                                 : `${Number(item?.totalGhgEmission).toFixed(
                                   4
                                 )}tCO2`} */}
                                {`${Number(item?.totalGhgEmission).toFixed(
                                  4
                                )}tCO2`}
                              </div>
                              <div>
                                {/* {Number(item?.baselineEmission).toFixed(4) <
                                 0.0001
                                 ? `${(
                                   Number(item?.baselineEmission) * 1000
                                 ).toFixed(4)}kgCO2`
                                 : `${Number(item?.baselineEmission).toFixed(
                                   4
                                 )}tCO2`} */}
                                {`${Number(item?.baselineEmission).toFixed(
                                  4
                                )}tCO2`}
                              </div>
                              <div>
                                {/* {Number(item?.offset).toFixed(4) < 0.0001
                                 ? `${(Number(item?.offset) * 1000).toFixed(
                                   4
                                 )}kgCO2`
                                 : `${Number(item?.offset).toFixed(4)}tCO2`} */}
                                {`${Number(item?.offset).toFixed(4)}tCO2`}
                              </div>
                              {/* <div>In progress</div> */}
                              {/* <div>In progress</div> */}
                            </div>
                            <div className="table_body_container mobile">
                              <div>
                                {moment(parseInt(item?.createdAt))
                                  .startOf("mini")
                                  .fromNow()}
                              </div>
                              <div>
                                {Number(item?.totalGhgEmission)}
                                tCO2
                              </div>
                              <div>
                                {Number(item?.baselineEmission)}
                                tCO2
                              </div>
                              <div>
                                {Number(item?.offset)}
                                tCO2
                              </div>
                              {/* <div>In progress</div> */}
                              {/* <div>In progress</div> */}
                            </div>
                          </>


                        ))}
                    </>
                  )}

                  {!generalLoading && emissionOffsetData?.length < 1 && (
                    <div className="management-table-empty-state">
                      <svg
                        width="48"
                        height="48"
                        viewBox="0 0 48 48"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M29.1748 31.9901L32.0028 29.1631L44.0218 41.1821L41.1938 44.0091L29.1748 31.9901Z"
                          fill="#616161"
                        />
                        <path
                          d="M20 36C28.8366 36 36 28.8366 36 20C36 11.1634 28.8366 4 20 4C11.1634 4 4 11.1634 4 20C4 28.8366 11.1634 36 20 36Z"
                          fill="#616161"
                        />
                        <path
                          d="M32.4502 35.34L35.2772 32.512L43.9732 41.208L41.1452 44.036L32.4502 35.34Z"
                          fill="#37474F"
                        />
                        <path
                          d="M20 33C27.1797 33 33 27.1797 33 20C33 12.8203 27.1797 7 20 7C12.8203 7 7 12.8203 7 20C7 27.1797 12.8203 33 20 33Z"
                          fill="#00AED9"
                        />
                        <path
                          d="M26.8999 14.2C25.1999 12.2 22.6999 11 19.9999 11C17.2999 11 14.7999 12.2 13.0999 14.2C12.6999 14.6 12.7999 15.3 13.1999 15.6C13.5999 16 14.2999 15.9 14.5999 15.5C15.9999 13.9 17.8999 13 19.9999 13C22.0999 13 23.9999 13.9 25.3999 15.5C25.5999 15.7 25.8999 15.9 26.1999 15.9C26.3999 15.9 26.6999 15.8 26.7999 15.7C27.1999 15.3 27.1999 14.6 26.8999 14.2Z"
                          fill="#BBDEFB"
                        />
                      </svg>
                      Nothing to see here
                    </div>
                  )}
                </div>

                {ndcCalendar && (
                  <div className="calendar-modal">
                    <div className="calendar-modal__flex">
                      {`${moment(
                        `${currentYear}-${currentMonth + 1}`,
                        "YYYY-M"
                      ).format("MMMM")} ${currentYear}`}

                      <div>
                        <svg
                          width="12"
                          height="12"
                          viewBox="0 0 12 12"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          className="pointer"
                          onClick={handleDecrementMonth}
                        >
                          <rect
                            x="0.25"
                            y="0.25"
                            width="11.5"
                            height="11.5"
                            rx="1.75"
                            fill="white"
                          />
                          <rect
                            x="0.25"
                            y="0.25"
                            width="11.5"
                            height="11.5"
                            rx="1.75"
                            stroke="#E4E7EC"
                            stroke-width="0.5"
                          />
                          <path
                            d="M4.68888 6.18123L7.47538 8.83623C7.52187 8.88055 7.58364 8.90527 7.64788 8.90527C7.71211 8.90527 7.77388 8.88055 7.82038 8.83623L7.82338 8.83323C7.846 8.81174 7.86401 8.78588 7.87631 8.75721C7.88862 8.72854 7.89497 8.69767 7.89497 8.66648C7.89497 8.63528 7.88862 8.60441 7.87631 8.57574C7.86401 8.54708 7.846 8.52121 7.82338 8.49973L5.19938 5.99973L7.82338 3.50073C7.846 3.47924 7.86401 3.45338 7.87631 3.42471C7.88862 3.39604 7.89497 3.36517 7.89497 3.33398C7.89497 3.30278 7.88862 3.27191 7.87631 3.24324C7.86401 3.21458 7.846 3.18871 7.82338 3.16723L7.82038 3.16423C7.77388 3.1199 7.71211 3.09518 7.64788 3.09518C7.58364 3.09518 7.52187 3.1199 7.47538 3.16423L4.68888 5.81923C4.66437 5.84257 4.64486 5.87066 4.63153 5.90177C4.6182 5.93288 4.61133 5.96638 4.61133 6.00023C4.61133 6.03407 4.6182 6.06757 4.63153 6.09868C4.64486 6.1298 4.66437 6.15788 4.68888 6.18123Z"
                            fill="#667185"
                          />
                        </svg>

                        <svg
                          width="12"
                          height="12"
                          viewBox="0 0 12 12"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          className="pointer"
                          onClick={handleIncrementMonth}
                        >
                          <rect
                            x="0.25"
                            y="0.25"
                            width="11.5"
                            height="11.5"
                            rx="1.75"
                            fill="white"
                          />
                          <rect
                            x="0.25"
                            y="0.25"
                            width="11.5"
                            height="11.5"
                            rx="1.75"
                            stroke="#E4E7EC"
                            stroke-width="0.5"
                          />
                          <path
                            d="M7.31112 5.81877L4.52462 3.16377C4.47813 3.11945 4.41636 3.09473 4.35212 3.09473C4.28789 3.09473 4.22612 3.11945 4.17962 3.16377L4.17662 3.16677C4.154 3.18826 4.13599 3.21412 4.12369 3.24279C4.11138 3.27146 4.10503 3.30233 4.10503 3.33352C4.10503 3.36472 4.11138 3.39559 4.12369 3.42426C4.13599 3.45292 4.154 3.47879 4.17662 3.50027L6.80062 6.00027L4.17662 8.49927C4.154 8.52076 4.13599 8.54662 4.12369 8.57529C4.11138 8.60396 4.10503 8.63483 4.10503 8.66602C4.10503 8.69722 4.11138 8.72809 4.12369 8.75676C4.13599 8.78542 4.154 8.81129 4.17662 8.83277L4.17962 8.83577C4.22612 8.8801 4.28789 8.90482 4.35212 8.90482C4.41636 8.90482 4.47813 8.8801 4.52462 8.83577L7.31112 6.18077C7.33563 6.15743 7.35514 6.12934 7.36847 6.09823C7.3818 6.06712 7.38867 6.03362 7.38867 5.99977C7.38867 5.96593 7.3818 5.93243 7.36847 5.90132C7.35514 5.8702 7.33563 5.84212 7.31112 5.81877Z"
                            fill="#667185"
                          />
                        </svg>
                      </div>
                    </div>
                    {renderCalendarGridRange()}
                    {firstDate && lastDate ? (
                      <div className="calendar-modal__button-group">
                        <button
                          onClick={clearDateSelection}
                          disabled={inRangeLoading}
                        >
                          Cancel
                        </button>
                        <button
                          disabled={inRangeLoading}
                          onClick={handleGetEmissionDataInRange}
                        >
                          {inRangeLoading ? "Loading..." : "Confirm"}
                        </button>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                )}

                {openDownloadReport && (
                  <div className="card1__modal">
                    <div className="card1__modal__title">
                      Download Report
                      <svg
                        className="pointer"
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        onClick={() => setOpenDownloadReport(false)}
                      >
                        <path
                          d="M4.50488 11.4946L8.00022 7.99924L11.4955 11.4946M11.4955 4.50391L7.99955 7.99924L4.50488 4.50391"
                          stroke="#D42620"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </div>
                    <div className="card1__modal__group">
                      <div>From:</div>
                      <div>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="17"
                          viewBox="0 0 16 17"
                          fill="none"
                        >
                          <path
                            d="M5.60039 8.9C5.81256 8.9 6.01605 8.81571 6.16608 8.66569C6.31611 8.51566 6.40039 8.31217 6.40039 8.1C6.40039 7.88783 6.31611 7.68434 6.16608 7.53432C6.01605 7.38429 5.81256 7.3 5.60039 7.3C5.38822 7.3 5.18473 7.38429 5.03471 7.53432C4.88468 7.68434 4.80039 7.88783 4.80039 8.1C4.80039 8.31217 4.88468 8.51566 5.03471 8.66569C5.18473 8.81571 5.38822 8.9 5.60039 8.9ZM6.40039 10.5C6.40039 10.7122 6.31611 10.9157 6.16608 11.0657C6.01605 11.2157 5.81256 11.3 5.60039 11.3C5.38822 11.3 5.18473 11.2157 5.03471 11.0657C4.88468 10.9157 4.80039 10.7122 4.80039 10.5C4.80039 10.2878 4.88468 10.0843 5.03471 9.93432C5.18473 9.78429 5.38822 9.7 5.60039 9.7C5.81256 9.7 6.01605 9.78429 6.16608 9.93432C6.31611 10.0843 6.40039 10.2878 6.40039 10.5ZM8.00039 8.9C8.21256 8.9 8.41605 8.81571 8.56608 8.66569C8.71611 8.51566 8.80039 8.31217 8.80039 8.1C8.80039 7.88783 8.71611 7.68434 8.56608 7.53432C8.41605 7.38429 8.21256 7.3 8.00039 7.3C7.78822 7.3 7.58473 7.38429 7.43471 7.53432C7.28468 7.68434 7.20039 7.88783 7.20039 8.1C7.20039 8.31217 7.28468 8.51566 7.43471 8.66569C7.58473 8.81571 7.78822 8.9 8.00039 8.9ZM8.80039 10.5C8.80039 10.7122 8.71611 10.9157 8.56608 11.0657C8.41605 11.2157 8.21256 11.3 8.00039 11.3C7.78822 11.3 7.58473 11.2157 7.43471 11.0657C7.28468 10.9157 7.20039 10.7122 7.20039 10.5C7.20039 10.2878 7.28468 10.0843 7.43471 9.93432C7.58473 9.78429 7.78822 9.7 8.00039 9.7C8.21256 9.7 8.41605 9.78429 8.56608 9.93432C8.71611 10.0843 8.80039 10.2878 8.80039 10.5ZM10.4004 8.9C10.6126 8.9 10.816 8.81571 10.9661 8.66569C11.1161 8.51566 11.2004 8.31217 11.2004 8.1C11.2004 7.88783 11.1161 7.68434 10.9661 7.53432C10.816 7.38429 10.6126 7.3 10.4004 7.3C10.1882 7.3 9.98474 7.38429 9.83471 7.53432C9.68468 7.68434 9.60039 7.88783 9.60039 8.1C9.60039 8.31217 9.68468 8.51566 9.83471 8.66569C9.98474 8.81571 10.1882 8.9 10.4004 8.9ZM13.6004 4.5C13.6004 3.96957 13.3897 3.46086 13.0146 3.08579C12.6395 2.71071 12.1308 2.5 11.6004 2.5H4.40039C3.86996 2.5 3.36125 2.71071 2.98618 3.08579C2.6111 3.46086 2.40039 3.96957 2.40039 4.5V11.7C2.40039 12.2304 2.6111 12.7391 2.98618 13.1142C3.36125 13.4893 3.86996 13.7 4.40039 13.7H11.6004C12.1308 13.7 12.6395 13.4893 13.0146 13.1142C13.3897 12.7391 13.6004 12.2304 13.6004 11.7V4.5ZM3.20039 5.7H12.8004V11.7C12.8004 12.0183 12.674 12.3235 12.4489 12.5485C12.2239 12.7736 11.9187 12.9 11.6004 12.9H4.40039C4.08213 12.9 3.77691 12.7736 3.55186 12.5485C3.32682 12.3235 3.20039 12.0183 3.20039 11.7V5.7ZM4.40039 3.3H11.6004C11.9187 3.3 12.2239 3.42643 12.4489 3.65147C12.674 3.87652 12.8004 4.18174 12.8004 4.5V4.9H3.20039V4.5C3.20039 4.18174 3.32682 3.87652 3.55186 3.65147C3.77691 3.42643 4.08213 3.3 4.40039 3.3Z"
                            fill="#747474"
                          />
                        </svg>
                        {firstDate}
                      </div>
                    </div>
                    <div className="card1__modal__group">
                      <div>To:</div>
                      <div>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="17"
                          viewBox="0 0 16 17"
                          fill="none"
                        >
                          <path
                            d="M5.60039 8.9C5.81256 8.9 6.01605 8.81571 6.16608 8.66569C6.31611 8.51566 6.40039 8.31217 6.40039 8.1C6.40039 7.88783 6.31611 7.68434 6.16608 7.53432C6.01605 7.38429 5.81256 7.3 5.60039 7.3C5.38822 7.3 5.18473 7.38429 5.03471 7.53432C4.88468 7.68434 4.80039 7.88783 4.80039 8.1C4.80039 8.31217 4.88468 8.51566 5.03471 8.66569C5.18473 8.81571 5.38822 8.9 5.60039 8.9ZM6.40039 10.5C6.40039 10.7122 6.31611 10.9157 6.16608 11.0657C6.01605 11.2157 5.81256 11.3 5.60039 11.3C5.38822 11.3 5.18473 11.2157 5.03471 11.0657C4.88468 10.9157 4.80039 10.7122 4.80039 10.5C4.80039 10.2878 4.88468 10.0843 5.03471 9.93432C5.18473 9.78429 5.38822 9.7 5.60039 9.7C5.81256 9.7 6.01605 9.78429 6.16608 9.93432C6.31611 10.0843 6.40039 10.2878 6.40039 10.5ZM8.00039 8.9C8.21256 8.9 8.41605 8.81571 8.56608 8.66569C8.71611 8.51566 8.80039 8.31217 8.80039 8.1C8.80039 7.88783 8.71611 7.68434 8.56608 7.53432C8.41605 7.38429 8.21256 7.3 8.00039 7.3C7.78822 7.3 7.58473 7.38429 7.43471 7.53432C7.28468 7.68434 7.20039 7.88783 7.20039 8.1C7.20039 8.31217 7.28468 8.51566 7.43471 8.66569C7.58473 8.81571 7.78822 8.9 8.00039 8.9ZM8.80039 10.5C8.80039 10.7122 8.71611 10.9157 8.56608 11.0657C8.41605 11.2157 8.21256 11.3 8.00039 11.3C7.78822 11.3 7.58473 11.2157 7.43471 11.0657C7.28468 10.9157 7.20039 10.7122 7.20039 10.5C7.20039 10.2878 7.28468 10.0843 7.43471 9.93432C7.58473 9.78429 7.78822 9.7 8.00039 9.7C8.21256 9.7 8.41605 9.78429 8.56608 9.93432C8.71611 10.0843 8.80039 10.2878 8.80039 10.5ZM10.4004 8.9C10.6126 8.9 10.816 8.81571 10.9661 8.66569C11.1161 8.51566 11.2004 8.31217 11.2004 8.1C11.2004 7.88783 11.1161 7.68434 10.9661 7.53432C10.816 7.38429 10.6126 7.3 10.4004 7.3C10.1882 7.3 9.98474 7.38429 9.83471 7.53432C9.68468 7.68434 9.60039 7.88783 9.60039 8.1C9.60039 8.31217 9.68468 8.51566 9.83471 8.66569C9.98474 8.81571 10.1882 8.9 10.4004 8.9ZM13.6004 4.5C13.6004 3.96957 13.3897 3.46086 13.0146 3.08579C12.6395 2.71071 12.1308 2.5 11.6004 2.5H4.40039C3.86996 2.5 3.36125 2.71071 2.98618 3.08579C2.6111 3.46086 2.40039 3.96957 2.40039 4.5V11.7C2.40039 12.2304 2.6111 12.7391 2.98618 13.1142C3.36125 13.4893 3.86996 13.7 4.40039 13.7H11.6004C12.1308 13.7 12.6395 13.4893 13.0146 13.1142C13.3897 12.7391 13.6004 12.2304 13.6004 11.7V4.5ZM3.20039 5.7H12.8004V11.7C12.8004 12.0183 12.674 12.3235 12.4489 12.5485C12.2239 12.7736 11.9187 12.9 11.6004 12.9H4.40039C4.08213 12.9 3.77691 12.7736 3.55186 12.5485C3.32682 12.3235 3.20039 12.0183 3.20039 11.7V5.7ZM4.40039 3.3H11.6004C11.9187 3.3 12.2239 3.42643 12.4489 3.65147C12.674 3.87652 12.8004 4.18174 12.8004 4.5V4.9H3.20039V4.5C3.20039 4.18174 3.32682 3.87652 3.55186 3.65147C3.77691 3.42643 4.08213 3.3 4.40039 3.3Z"
                            fill="#747474"
                          />
                        </svg>
                        {lastDate}
                      </div>
                    </div>

                    <PDFDownloadLink
                      document={
                        <EmissionsReport
                          totalEmission={reportTotalEmission}
                          timeFrame={`${firstDate} ${lastDate}`}
                          organizationName={user?.companyName}
                          emissionsData={emissionOffsetData}
                        // fuelType={fuelType}
                        // fuelConsumed={fuelConsumed}
                        />
                      }
                      fileName={`${user?.companyName}-Netzence emission report.pdf`}
                      style={{ textDecoration: "none" }}
                    >

                      <button className="card1__modal__button">Download</button>
                    </PDFDownloadLink>
                  </div>
                )}
              </div>
              <div className="card2"></div>
            </div>
          </div>

          <div className="main__emission-group__faq">
            <div className="main__emission-group__faq__title-group">
              <div>Frequently asked questions (FAQs)</div>
              <div>See all</div>
            </div>

            <div
              className="main__emission-group__faq__card"
              onClick={() => (openFaq === 0 ? setOpenFaq(null) : setOpenFaq(0))}
            >
              <div className="main__emission-group__faq__card__inner">
                <div>What is emission reduction and why is it important?</div>
                {openFaq === 0 ? (
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 33 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="16.5"
                      cy="16"
                      r="16"
                      fill="#0D924F"
                      fill-opacity="0.3"
                    />
                    <path
                      d="M11.833 16H21.1663"
                      stroke="#3B3B3B"
                      stroke-width="1.33333"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                ) : (
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 33 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="16.5"
                      cy="16"
                      r="16"
                      fill="#0D924F"
                      fill-opacity="0.3"
                    />
                    <path
                      d="M16.3333 11C16.4659 11 16.5931 11.0527 16.6869 11.1464C16.7807 11.2402 16.8333 11.3674 16.8333 11.5V15.3333H20.6667C20.7993 15.3333 20.9265 15.386 21.0202 15.4798C21.114 15.5735 21.1667 15.7007 21.1667 15.8333C21.1667 15.9659 21.114 16.0931 21.0202 16.1869C20.9265 16.2807 20.7993 16.3333 20.6667 16.3333H16.8333V20.1667C16.8333 20.2993 16.7807 20.4265 16.6869 20.5202C16.5931 20.614 16.4659 20.6667 16.3333 20.6667C16.2007 20.6667 16.0735 20.614 15.9798 20.5202C15.886 20.4265 15.8333 20.2993 15.8333 20.1667V16.3333H12C11.8674 16.3333 11.7402 16.2807 11.6464 16.1869C11.5527 16.0931 11.5 15.9659 11.5 15.8333C11.5 15.7007 11.5527 15.5735 11.6464 15.4798C11.7402 15.386 11.8674 15.3333 12 15.3333H15.8333V11.5C15.8333 11.3674 15.886 11.2402 15.9798 11.1464C16.0735 11.0527 16.2007 11 16.3333 11Z"
                      fill="#3B3B3B"
                    />
                  </svg>
                )}
              </div>
              <div>
                {openFaq === 0 && (
                  <div className="subtitle">
                    Emission reduction means lowering the amount of harmful
                    gases, like carbon dioxide (CO2), released into the air.
                    These gases trap heat and cause the earth's climate to
                    change. Reducing emissions is important because it helps
                    prevent problems like severe weather, loss of animal and
                    plant life, and health issues for people. By cutting down on
                    these gases, we protect our planet and improve well-being.
                  </div>
                )}
              </div>
            </div>
            <div
              className="main__emission-group__faq__card"
              onClick={() => (openFaq === 1 ? setOpenFaq(null) : setOpenFaq(1))}
            >
              <div className="main__emission-group__faq__card__inner">
                <div>
                  How does CloseCarbon help in reducing carbon emissions?
                </div>
                {openFaq === 1 ? (
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 33 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="16.5"
                      cy="16"
                      r="16"
                      fill="#0D924F"
                      fill-opacity="0.3"
                    />
                    <path
                      d="M11.833 16H21.1663"
                      stroke="#3B3B3B"
                      stroke-width="1.33333"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                ) : (
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 33 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="16.5"
                      cy="16"
                      r="16"
                      fill="#0D924F"
                      fill-opacity="0.3"
                    />
                    <path
                      d="M16.3333 11C16.4659 11 16.5931 11.0527 16.6869 11.1464C16.7807 11.2402 16.8333 11.3674 16.8333 11.5V15.3333H20.6667C20.7993 15.3333 20.9265 15.386 21.0202 15.4798C21.114 15.5735 21.1667 15.7007 21.1667 15.8333C21.1667 15.9659 21.114 16.0931 21.0202 16.1869C20.9265 16.2807 20.7993 16.3333 20.6667 16.3333H16.8333V20.1667C16.8333 20.2993 16.7807 20.4265 16.6869 20.5202C16.5931 20.614 16.4659 20.6667 16.3333 20.6667C16.2007 20.6667 16.0735 20.614 15.9798 20.5202C15.886 20.4265 15.8333 20.2993 15.8333 20.1667V16.3333H12C11.8674 16.3333 11.7402 16.2807 11.6464 16.1869C11.5527 16.0931 11.5 15.9659 11.5 15.8333C11.5 15.7007 11.5527 15.5735 11.6464 15.4798C11.7402 15.386 11.8674 15.3333 12 15.3333H15.8333V11.5C15.8333 11.3674 15.886 11.2402 15.9798 11.1464C16.0735 11.0527 16.2007 11 16.3333 11Z"
                      fill="#3B3B3B"
                    />
                  </svg>
                )}
              </div>
              <div>
                {openFaq === 1 && (
                  <div className="subtitle">
                    CloseCarbon helps reduce carbon emissions by providing a
                    platform for individuals and organizations to validate and
                    verify their efforts to cut down on carbon, both green and
                    non-green projects which is done by ensuring transparency
                    and encourages more efforts towards reducing carbon
                    emissions.
                  </div>
                )}
              </div>
            </div>
            <div
              className="main__emission-group__faq__card"
              onClick={() => (openFaq === 2 ? setOpenFaq(null) : setOpenFaq(2))}
            >
              <div className="main__emission-group__faq__card__inner">
                <div>
                  What types of projects are included in CloseCarbon’s emission
                  reduction efforts?
                </div>
                {openFaq === 2 ? (
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 33 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="16.5"
                      cy="16"
                      r="16"
                      fill="#0D924F"
                      fill-opacity="0.3"
                    />
                    <path
                      d="M11.833 16H21.1663"
                      stroke="#3B3B3B"
                      stroke-width="1.33333"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                ) : (
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 33 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="16.5"
                      cy="16"
                      r="16"
                      fill="#0D924F"
                      fill-opacity="0.3"
                    />
                    <path
                      d="M16.3333 11C16.4659 11 16.5931 11.0527 16.6869 11.1464C16.7807 11.2402 16.8333 11.3674 16.8333 11.5V15.3333H20.6667C20.7993 15.3333 20.9265 15.386 21.0202 15.4798C21.114 15.5735 21.1667 15.7007 21.1667 15.8333C21.1667 15.9659 21.114 16.0931 21.0202 16.1869C20.9265 16.2807 20.7993 16.3333 20.6667 16.3333H16.8333V20.1667C16.8333 20.2993 16.7807 20.4265 16.6869 20.5202C16.5931 20.614 16.4659 20.6667 16.3333 20.6667C16.2007 20.6667 16.0735 20.614 15.9798 20.5202C15.886 20.4265 15.8333 20.2993 15.8333 20.1667V16.3333H12C11.8674 16.3333 11.7402 16.2807 11.6464 16.1869C11.5527 16.0931 11.5 15.9659 11.5 15.8333C11.5 15.7007 11.5527 15.5735 11.6464 15.4798C11.7402 15.386 11.8674 15.3333 12 15.3333H15.8333V11.5C15.8333 11.3674 15.886 11.2402 15.9798 11.1464C16.0735 11.0527 16.2007 11 16.3333 11Z"
                      fill="#3B3B3B"
                    />
                  </svg>
                )}
              </div>
              <div>
                {openFaq === 2 && (
                  <div className="subtitle">
                    CloseCarbon supports
                    <br />
                    <br />
                    -Green projects: these are projects initiatives aimed at
                    promoting environmental sustainability by reducing carbon
                    footprints, conserving natural resources, and enhancing
                    ecosystem health through activities like renewable energy
                    generation, reforestation, and sustainable agriculture.
                    <br />
                    <br />
                    -Non-green projects: these are projects that may involve
                    high carbon emissions, resource depletion, or activities
                    harmful to ecosystems.
                  </div>
                )}
              </div>
            </div>
            <div
              className="main__emission-group__faq__card"
              onClick={() => (openFaq === 3 ? setOpenFaq(null) : setOpenFaq(3))}
            >
              <div className="main__emission-group__faq__card__inner">
                <div>
                  How can businesses benefit from participating in emission
                  reduction programs?
                </div>
                {openFaq === 3 ? (
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 33 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="16.5"
                      cy="16"
                      r="16"
                      fill="#0D924F"
                      fill-opacity="0.3"
                    />
                    <path
                      d="M11.833 16H21.1663"
                      stroke="#3B3B3B"
                      stroke-width="1.33333"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                ) : (
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 33 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="16.5"
                      cy="16"
                      r="16"
                      fill="#0D924F"
                      fill-opacity="0.3"
                    />
                    <path
                      d="M16.3333 11C16.4659 11 16.5931 11.0527 16.6869 11.1464C16.7807 11.2402 16.8333 11.3674 16.8333 11.5V15.3333H20.6667C20.7993 15.3333 20.9265 15.386 21.0202 15.4798C21.114 15.5735 21.1667 15.7007 21.1667 15.8333C21.1667 15.9659 21.114 16.0931 21.0202 16.1869C20.9265 16.2807 20.7993 16.3333 20.6667 16.3333H16.8333V20.1667C16.8333 20.2993 16.7807 20.4265 16.6869 20.5202C16.5931 20.614 16.4659 20.6667 16.3333 20.6667C16.2007 20.6667 16.0735 20.614 15.9798 20.5202C15.886 20.4265 15.8333 20.2993 15.8333 20.1667V16.3333H12C11.8674 16.3333 11.7402 16.2807 11.6464 16.1869C11.5527 16.0931 11.5 15.9659 11.5 15.8333C11.5 15.7007 11.5527 15.5735 11.6464 15.4798C11.7402 15.386 11.8674 15.3333 12 15.3333H15.8333V11.5C15.8333 11.3674 15.886 11.2402 15.9798 11.1464C16.0735 11.0527 16.2007 11 16.3333 11Z"
                      fill="#3B3B3B"
                    />
                  </svg>
                )}
              </div>
              <div>
                {openFaq === 3 && (
                  <div className="subtitle">
                    Businesses can benefit from emission reduction programs by
                    being environmentally friendly, reducing operational costs
                    and meeting regulatory requirements. These programs also
                    provides market advantages and help mitigate risks
                    associated with climate change impacts.{" "}
                  </div>
                )}
              </div>
            </div>
            <div
              className="main__emission-group__faq__card"
              onClick={() => (openFaq === 4 ? setOpenFaq(null) : setOpenFaq(4))}
            >
              <div className="main__emission-group__faq__card__inner">
                <div>What is CloseCarbon Reduction Tonne?</div>
                {openFaq === 4 ? (
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 33 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="16.5"
                      cy="16"
                      r="16"
                      fill="#0D924F"
                      fill-opacity="0.3"
                    />
                    <path
                      d="M11.833 16H21.1663"
                      stroke="#3B3B3B"
                      stroke-width="1.33333"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                ) : (
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 33 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="16.5"
                      cy="16"
                      r="16"
                      fill="#0D924F"
                      fill-opacity="0.3"
                    />
                    <path
                      d="M16.3333 11C16.4659 11 16.5931 11.0527 16.6869 11.1464C16.7807 11.2402 16.8333 11.3674 16.8333 11.5V15.3333H20.6667C20.7993 15.3333 20.9265 15.386 21.0202 15.4798C21.114 15.5735 21.1667 15.7007 21.1667 15.8333C21.1667 15.9659 21.114 16.0931 21.0202 16.1869C20.9265 16.2807 20.7993 16.3333 20.6667 16.3333H16.8333V20.1667C16.8333 20.2993 16.7807 20.4265 16.6869 20.5202C16.5931 20.614 16.4659 20.6667 16.3333 20.6667C16.2007 20.6667 16.0735 20.614 15.9798 20.5202C15.886 20.4265 15.8333 20.2993 15.8333 20.1667V16.3333H12C11.8674 16.3333 11.7402 16.2807 11.6464 16.1869C11.5527 16.0931 11.5 15.9659 11.5 15.8333C11.5 15.7007 11.5527 15.5735 11.6464 15.4798C11.7402 15.386 11.8674 15.3333 12 15.3333H15.8333V11.5C15.8333 11.3674 15.886 11.2402 15.9798 11.1464C16.0735 11.0527 16.2007 11 16.3333 11Z"
                      fill="#3B3B3B"
                    />
                  </svg>
                )}
              </div>
              <div>
                {openFaq === 4 && (
                  <div className="subtitle">
                    CloseCarbon Reduction Tonne (CCRT) is issued by CloseCarbon
                    after confirming that carbon emission reduction data meets
                    specific standards. One CCRT represent approximately about
                    one tonne of carbondioxide (CO2) that has been emitted.{" "}
                  </div>
                )}
              </div>
            </div>
            <div
              className="main__emission-group__faq__card"
              onClick={() => (openFaq === 5 ? setOpenFaq(null) : setOpenFaq(5))}
            >
              <div className="main__emission-group__faq__card__inner">
                <div>How’s verification carried out?</div>
                {openFaq === 5 ? (
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 33 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="16.5"
                      cy="16"
                      r="16"
                      fill="#0D924F"
                      fill-opacity="0.3"
                    />
                    <path
                      d="M11.833 16H21.1663"
                      stroke="#3B3B3B"
                      stroke-width="1.33333"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                ) : (
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 33 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="16.5"
                      cy="16"
                      r="16"
                      fill="#0D924F"
                      fill-opacity="0.3"
                    />
                    <path
                      d="M16.3333 11C16.4659 11 16.5931 11.0527 16.6869 11.1464C16.7807 11.2402 16.8333 11.3674 16.8333 11.5V15.3333H20.6667C20.7993 15.3333 20.9265 15.386 21.0202 15.4798C21.114 15.5735 21.1667 15.7007 21.1667 15.8333C21.1667 15.9659 21.114 16.0931 21.0202 16.1869C20.9265 16.2807 20.7993 16.3333 20.6667 16.3333H16.8333V20.1667C16.8333 20.2993 16.7807 20.4265 16.6869 20.5202C16.5931 20.614 16.4659 20.6667 16.3333 20.6667C16.2007 20.6667 16.0735 20.614 15.9798 20.5202C15.886 20.4265 15.8333 20.2993 15.8333 20.1667V16.3333H12C11.8674 16.3333 11.7402 16.2807 11.6464 16.1869C11.5527 16.0931 11.5 15.9659 11.5 15.8333C11.5 15.7007 11.5527 15.5735 11.6464 15.4798C11.7402 15.386 11.8674 15.3333 12 15.3333H15.8333V11.5C15.8333 11.3674 15.886 11.2402 15.9798 11.1464C16.0735 11.0527 16.2007 11 16.3333 11Z"
                      fill="#3B3B3B"
                    />
                  </svg>
                )}
              </div>
              <div>
                {openFaq === 5 && (
                  <div className="subtitle">
                    Verification is carried out by third-party organizations
                    that independently review and verify the emission data of
                    projects. These organizations ensure that the projects meet
                    specific standards and that the reported emission reductions
                    are accurate and credible.
                  </div>
                )}
              </div>
            </div>
            <div
              className="main__emission-group__faq__card"
              onClick={() => (openFaq === 6 ? setOpenFaq(null) : setOpenFaq(6))}
            >
              <div className="main__emission-group__faq__card__inner">
                <div>Are these offsets verified by a third party?</div>
                {openFaq === 6 ? (
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 33 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="16.5"
                      cy="16"
                      r="16"
                      fill="#0D924F"
                      fill-opacity="0.3"
                    />
                    <path
                      d="M11.833 16H21.1663"
                      stroke="#3B3B3B"
                      stroke-width="1.33333"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                ) : (
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 33 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="16.5"
                      cy="16"
                      r="16"
                      fill="#0D924F"
                      fill-opacity="0.3"
                    />
                    <path
                      d="M16.3333 11C16.4659 11 16.5931 11.0527 16.6869 11.1464C16.7807 11.2402 16.8333 11.3674 16.8333 11.5V15.3333H20.6667C20.7993 15.3333 20.9265 15.386 21.0202 15.4798C21.114 15.5735 21.1667 15.7007 21.1667 15.8333C21.1667 15.9659 21.114 16.0931 21.0202 16.1869C20.9265 16.2807 20.7993 16.3333 20.6667 16.3333H16.8333V20.1667C16.8333 20.2993 16.7807 20.4265 16.6869 20.5202C16.5931 20.614 16.4659 20.6667 16.3333 20.6667C16.2007 20.6667 16.0735 20.614 15.9798 20.5202C15.886 20.4265 15.8333 20.2993 15.8333 20.1667V16.3333H12C11.8674 16.3333 11.7402 16.2807 11.6464 16.1869C11.5527 16.0931 11.5 15.9659 11.5 15.8333C11.5 15.7007 11.5527 15.5735 11.6464 15.4798C11.7402 15.386 11.8674 15.3333 12 15.3333H15.8333V11.5C15.8333 11.3674 15.886 11.2402 15.9798 11.1464C16.0735 11.0527 16.2007 11 16.3333 11Z"
                      fill="#3B3B3B"
                    />
                  </svg>
                )}
              </div>
              <div>
                {openFaq === 6 && (
                  <div className="subtitle">
                    Yes, third-party organizations verify these offsets. These
                    entities provide an object assessment to ensure that the
                    projects genuinely reduce emissions as claimed.
                  </div>
                )}
              </div>
            </div>
            <div
              className="main__emission-group__faq__card"
              onClick={() => (openFaq === 7 ? setOpenFaq(null) : setOpenFaq(7))}
            >
              <div className="main__emission-group__faq__card__inner">
                <div>What standards are used for verifying carbon offsets?</div>
                {openFaq === 7 ? (
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 33 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="16.5"
                      cy="16"
                      r="16"
                      fill="#0D924F"
                      fill-opacity="0.3"
                    />
                    <path
                      d="M11.833 16H21.1663"
                      stroke="#3B3B3B"
                      stroke-width="1.33333"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                ) : (
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 33 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="16.5"
                      cy="16"
                      r="16"
                      fill="#0D924F"
                      fill-opacity="0.3"
                    />
                    <path
                      d="M16.3333 11C16.4659 11 16.5931 11.0527 16.6869 11.1464C16.7807 11.2402 16.8333 11.3674 16.8333 11.5V15.3333H20.6667C20.7993 15.3333 20.9265 15.386 21.0202 15.4798C21.114 15.5735 21.1667 15.7007 21.1667 15.8333C21.1667 15.9659 21.114 16.0931 21.0202 16.1869C20.9265 16.2807 20.7993 16.3333 20.6667 16.3333H16.8333V20.1667C16.8333 20.2993 16.7807 20.4265 16.6869 20.5202C16.5931 20.614 16.4659 20.6667 16.3333 20.6667C16.2007 20.6667 16.0735 20.614 15.9798 20.5202C15.886 20.4265 15.8333 20.2993 15.8333 20.1667V16.3333H12C11.8674 16.3333 11.7402 16.2807 11.6464 16.1869C11.5527 16.0931 11.5 15.9659 11.5 15.8333C11.5 15.7007 11.5527 15.5735 11.6464 15.4798C11.7402 15.386 11.8674 15.3333 12 15.3333H15.8333V11.5C15.8333 11.3674 15.886 11.2402 15.9798 11.1464C16.0735 11.0527 16.2007 11 16.3333 11Z"
                      fill="#3B3B3B"
                    />
                  </svg>
                )}
              </div>
              <div>
                {openFaq === 7 && (
                  <div className="subtitle">
                    Carbon offsets are verified by using established standards
                    like the Gold Standard, Verified Carbon Standard (VCS), and
                    Climate Action Reserve. These standards ensure that projects
                    meet criteria for environmental integrity and transparency.
                  </div>
                )}
              </div>
            </div>
            <div
              className="main__emission-group__faq__card"
              onClick={() => (openFaq === 8 ? setOpenFaq(null) : setOpenFaq(8))}
            >
              <div className="main__emission-group__faq__card__inner">
                <div>
                  How often are the offset projects re-evaluated to ensure
                  ongoing compliance?
                </div>
                {openFaq === 8 ? (
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 33 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="16.5"
                      cy="16"
                      r="16"
                      fill="#0D924F"
                      fill-opacity="0.3"
                    />
                    <path
                      d="M11.833 16H21.1663"
                      stroke="#3B3B3B"
                      stroke-width="1.33333"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                ) : (
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 33 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="16.5"
                      cy="16"
                      r="16"
                      fill="#0D924F"
                      fill-opacity="0.3"
                    />
                    <path
                      d="M16.3333 11C16.4659 11 16.5931 11.0527 16.6869 11.1464C16.7807 11.2402 16.8333 11.3674 16.8333 11.5V15.3333H20.6667C20.7993 15.3333 20.9265 15.386 21.0202 15.4798C21.114 15.5735 21.1667 15.7007 21.1667 15.8333C21.1667 15.9659 21.114 16.0931 21.0202 16.1869C20.9265 16.2807 20.7993 16.3333 20.6667 16.3333H16.8333V20.1667C16.8333 20.2993 16.7807 20.4265 16.6869 20.5202C16.5931 20.614 16.4659 20.6667 16.3333 20.6667C16.2007 20.6667 16.0735 20.614 15.9798 20.5202C15.886 20.4265 15.8333 20.2993 15.8333 20.1667V16.3333H12C11.8674 16.3333 11.7402 16.2807 11.6464 16.1869C11.5527 16.0931 11.5 15.9659 11.5 15.8333C11.5 15.7007 11.5527 15.5735 11.6464 15.4798C11.7402 15.386 11.8674 15.3333 12 15.3333H15.8333V11.5C15.8333 11.3674 15.886 11.2402 15.9798 11.1464C16.0735 11.0527 16.2007 11 16.3333 11Z"
                      fill="#3B3B3B"
                    />
                  </svg>
                )}
              </div>
              <div>
                {openFaq === 8 && (
                  <div className="subtitle">
                    Offset projects are usually re-evaluated on a periodic
                    basis, often annually or biannually, depending on the
                    specific requirements of the verification standard being
                    used. This re-evaluation ensures that the projects continue
                    to deliver the promised emission reductions and adhere to
                    the necessary compliance standards.
                  </div>
                )}
              </div>
            </div>
            <div
              className="main__emission-group__faq__card"
              onClick={() => (openFaq === 9 ? setOpenFaq(null) : setOpenFaq(9))}
            >
              <div className="main__emission-group__faq__card__inner">
                <div>What are the features included in Basic plan?</div>
                {openFaq === 9 ? (
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 33 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="16.5"
                      cy="16"
                      r="16"
                      fill="#0D924F"
                      fill-opacity="0.3"
                    />
                    <path
                      d="M11.833 16H21.1663"
                      stroke="#3B3B3B"
                      stroke-width="1.33333"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                ) : (
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 33 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="16.5"
                      cy="16"
                      r="16"
                      fill="#0D924F"
                      fill-opacity="0.3"
                    />
                    <path
                      d="M16.3333 11C16.4659 11 16.5931 11.0527 16.6869 11.1464C16.7807 11.2402 16.8333 11.3674 16.8333 11.5V15.3333H20.6667C20.7993 15.3333 20.9265 15.386 21.0202 15.4798C21.114 15.5735 21.1667 15.7007 21.1667 15.8333C21.1667 15.9659 21.114 16.0931 21.0202 16.1869C20.9265 16.2807 20.7993 16.3333 20.6667 16.3333H16.8333V20.1667C16.8333 20.2993 16.7807 20.4265 16.6869 20.5202C16.5931 20.614 16.4659 20.6667 16.3333 20.6667C16.2007 20.6667 16.0735 20.614 15.9798 20.5202C15.886 20.4265 15.8333 20.2993 15.8333 20.1667V16.3333H12C11.8674 16.3333 11.7402 16.2807 11.6464 16.1869C11.5527 16.0931 11.5 15.9659 11.5 15.8333C11.5 15.7007 11.5527 15.5735 11.6464 15.4798C11.7402 15.386 11.8674 15.3333 12 15.3333H15.8333V11.5C15.8333 11.3674 15.886 11.2402 15.9798 11.1464C16.0735 11.0527 16.2007 11 16.3333 11Z"
                      fill="#3B3B3B"
                    />
                  </svg>
                )}
              </div>
              <div>
                {openFaq === 9 && (
                  <div className="subtitle">
                    The Basic plan includes verifying and tracking of carbon
                    emissions, issuing carbon credits as proof of your efforts,
                    and providing real-time insights to help monitor and manage
                    emissions easily.
                  </div>
                )}
              </div>
            </div>
            <div
              className="main__emission-group__faq__card"
              onClick={() =>
                openFaq === 10 ? setOpenFaq(null) : setOpenFaq(10)
              }
            >
              <div className="main__emission-group__faq__card__inner">
                <div>
                  How does the Governance plan differ from the Basic plan?
                </div>
                {openFaq === 10 ? (
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 33 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="16.5"
                      cy="16"
                      r="16"
                      fill="#0D924F"
                      fill-opacity="0.3"
                    />
                    <path
                      d="M11.833 16H21.1663"
                      stroke="#3B3B3B"
                      stroke-width="1.33333"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                ) : (
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 33 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="16.5"
                      cy="16"
                      r="16"
                      fill="#0D924F"
                      fill-opacity="0.3"
                    />
                    <path
                      d="M16.3333 11C16.4659 11 16.5931 11.0527 16.6869 11.1464C16.7807 11.2402 16.8333 11.3674 16.8333 11.5V15.3333H20.6667C20.7993 15.3333 20.9265 15.386 21.0202 15.4798C21.114 15.5735 21.1667 15.7007 21.1667 15.8333C21.1667 15.9659 21.114 16.0931 21.0202 16.1869C20.9265 16.2807 20.7993 16.3333 20.6667 16.3333H16.8333V20.1667C16.8333 20.2993 16.7807 20.4265 16.6869 20.5202C16.5931 20.614 16.4659 20.6667 16.3333 20.6667C16.2007 20.6667 16.0735 20.614 15.9798 20.5202C15.886 20.4265 15.8333 20.2993 15.8333 20.1667V16.3333H12C11.8674 16.3333 11.7402 16.2807 11.6464 16.1869C11.5527 16.0931 11.5 15.9659 11.5 15.8333C11.5 15.7007 11.5527 15.5735 11.6464 15.4798C11.7402 15.386 11.8674 15.3333 12 15.3333H15.8333V11.5C15.8333 11.3674 15.886 11.2402 15.9798 11.1464C16.0735 11.0527 16.2007 11 16.3333 11Z"
                      fill="#3B3B3B"
                    />
                  </svg>
                )}
              </div>
              <div>
                {openFaq === 10 && (
                  <div className="subtitle">
                    The Governance plan includes all features in the Basic plan,
                    such as verification, validation, and carbon credits.
                    Additionally, it offers real-time tracking of Nationally
                    Determined Contributions (NDC) values which helps manage
                    sustainability goals transparently and effectively.
                  </div>
                )}
              </div>
            </div>
            <div
              className="main__emission-group__faq__card"
              onClick={() =>
                openFaq === 11 ? setOpenFaq(null) : setOpenFaq(11)
              }
            >
              <div className="main__emission-group__faq__card__inner">
                <div>
                  Which plan is best suited for businesses looking to actively
                  manage and verify their carbon offsets?
                </div>
                {openFaq === 11 ? (
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 33 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="16.5"
                      cy="16"
                      r="16"
                      fill="#0D924F"
                      fill-opacity="0.3"
                    />
                    <path
                      d="M11.833 16H21.1663"
                      stroke="#3B3B3B"
                      stroke-width="1.33333"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                ) : (
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 33 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="16.5"
                      cy="16"
                      r="16"
                      fill="#0D924F"
                      fill-opacity="0.3"
                    />
                    <path
                      d="M16.3333 11C16.4659 11 16.5931 11.0527 16.6869 11.1464C16.7807 11.2402 16.8333 11.3674 16.8333 11.5V15.3333H20.6667C20.7993 15.3333 20.9265 15.386 21.0202 15.4798C21.114 15.5735 21.1667 15.7007 21.1667 15.8333C21.1667 15.9659 21.114 16.0931 21.0202 16.1869C20.9265 16.2807 20.7993 16.3333 20.6667 16.3333H16.8333V20.1667C16.8333 20.2993 16.7807 20.4265 16.6869 20.5202C16.5931 20.614 16.4659 20.6667 16.3333 20.6667C16.2007 20.6667 16.0735 20.614 15.9798 20.5202C15.886 20.4265 15.8333 20.2993 15.8333 20.1667V16.3333H12C11.8674 16.3333 11.7402 16.2807 11.6464 16.1869C11.5527 16.0931 11.5 15.9659 11.5 15.8333C11.5 15.7007 11.5527 15.5735 11.6464 15.4798C11.7402 15.386 11.8674 15.3333 12 15.3333H15.8333V11.5C15.8333 11.3674 15.886 11.2402 15.9798 11.1464C16.0735 11.0527 16.2007 11 16.3333 11Z"
                      fill="#3B3B3B"
                    />
                  </svg>
                )}
              </div>
              <div>
                {openFaq === 11 && (
                  <div className="subtitle">
                    The basic plan and governance are the most suitable options.
                  </div>
                )}
              </div>
            </div>
            <div
              className="main__emission-group__faq__card"
              onClick={() =>
                openFaq === 12 ? setOpenFaq(null) : setOpenFaq(12)
              }
            >
              <div className="main__emission-group__faq__card__inner">
                <div>Why do I need to input my wallet address?</div>
                {openFaq === 12 ? (
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 33 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="16.5"
                      cy="16"
                      r="16"
                      fill="#0D924F"
                      fill-opacity="0.3"
                    />
                    <path
                      d="M11.833 16H21.1663"
                      stroke="#3B3B3B"
                      stroke-width="1.33333"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                ) : (
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 33 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="16.5"
                      cy="16"
                      r="16"
                      fill="#0D924F"
                      fill-opacity="0.3"
                    />
                    <path
                      d="M16.3333 11C16.4659 11 16.5931 11.0527 16.6869 11.1464C16.7807 11.2402 16.8333 11.3674 16.8333 11.5V15.3333H20.6667C20.7993 15.3333 20.9265 15.386 21.0202 15.4798C21.114 15.5735 21.1667 15.7007 21.1667 15.8333C21.1667 15.9659 21.114 16.0931 21.0202 16.1869C20.9265 16.2807 20.7993 16.3333 20.6667 16.3333H16.8333V20.1667C16.8333 20.2993 16.7807 20.4265 16.6869 20.5202C16.5931 20.614 16.4659 20.6667 16.3333 20.6667C16.2007 20.6667 16.0735 20.614 15.9798 20.5202C15.886 20.4265 15.8333 20.2993 15.8333 20.1667V16.3333H12C11.8674 16.3333 11.7402 16.2807 11.6464 16.1869C11.5527 16.0931 11.5 15.9659 11.5 15.8333C11.5 15.7007 11.5527 15.5735 11.6464 15.4798C11.7402 15.386 11.8674 15.3333 12 15.3333H15.8333V11.5C15.8333 11.3674 15.886 11.2402 15.9798 11.1464C16.0735 11.0527 16.2007 11 16.3333 11Z"
                      fill="#3B3B3B"
                    />
                  </svg>
                )}
              </div>
              <div>
                {openFaq === 12 && (
                  <div className="subtitle">
                    CloseCarbon require your Ethereum wallet address to securely
                    send your earned CloseCarbon Reduction Tonnes (CCRT)
                    directly to your wallet. Do not disclose your private key.
                  </div>
                )}
              </div>
            </div>
            <div
              className="main__emission-group__faq__card"
              onClick={() =>
                openFaq === 13 ? setOpenFaq(null) : setOpenFaq(13)
              }
            >
              <div className="main__emission-group__faq__card__inner">
                <div>How does the Voluntary Donation Pool work?</div>
                {openFaq === 13 ? (
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 33 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="16.5"
                      cy="16"
                      r="16"
                      fill="#0D924F"
                      fill-opacity="0.3"
                    />
                    <path
                      d="M11.833 16H21.1663"
                      stroke="#3B3B3B"
                      stroke-width="1.33333"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                ) : (
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 33 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="16.5"
                      cy="16"
                      r="16"
                      fill="#0D924F"
                      fill-opacity="0.3"
                    />
                    <path
                      d="M16.3333 11C16.4659 11 16.5931 11.0527 16.6869 11.1464C16.7807 11.2402 16.8333 11.3674 16.8333 11.5V15.3333H20.6667C20.7993 15.3333 20.9265 15.386 21.0202 15.4798C21.114 15.5735 21.1667 15.7007 21.1667 15.8333C21.1667 15.9659 21.114 16.0931 21.0202 16.1869C20.9265 16.2807 20.7993 16.3333 20.6667 16.3333H16.8333V20.1667C16.8333 20.2993 16.7807 20.4265 16.6869 20.5202C16.5931 20.614 16.4659 20.6667 16.3333 20.6667C16.2007 20.6667 16.0735 20.614 15.9798 20.5202C15.886 20.4265 15.8333 20.2993 15.8333 20.1667V16.3333H12C11.8674 16.3333 11.7402 16.2807 11.6464 16.1869C11.5527 16.0931 11.5 15.9659 11.5 15.8333C11.5 15.7007 11.5527 15.5735 11.6464 15.4798C11.7402 15.386 11.8674 15.3333 12 15.3333H15.8333V11.5C15.8333 11.3674 15.886 11.2402 15.9798 11.1464C16.0735 11.0527 16.2007 11 16.3333 11Z"
                      fill="#3B3B3B"
                    />
                  </svg>
                )}
              </div>
              <div>
                {openFaq === 13 && (
                  <div className="subtitle">
                    The Voluntary Donation Pool allows donors to contribute to
                    emission reduction efforts. Donations are used to purchase
                    CloseCarbon Reduction Tonnes (CCRTs), which represent
                    verified emission reductions. These CCRTs are allocated to
                    users whose emission reduction data meets the required
                    standards. This initiative not only supports environmental
                    projects but also incentivizes and rewards users for their
                    efforts in reducing carbon emissions.
                  </div>
                )}
              </div>
            </div>
            <div
              className="main__emission-group__faq__card"
              onClick={() =>
                openFaq === 14 ? setOpenFaq(null) : setOpenFaq(14)
              }
            >
              <div className="main__emission-group__faq__card__inner">
                <div>
                  What types of projects can I support through the Voluntary
                  Donation Pool?
                </div>
                {openFaq === 14 ? (
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 33 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="16.5"
                      cy="16"
                      r="16"
                      fill="#0D924F"
                      fill-opacity="0.3"
                    />
                    <path
                      d="M11.833 16H21.1663"
                      stroke="#3B3B3B"
                      stroke-width="1.33333"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                ) : (
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 33 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="16.5"
                      cy="16"
                      r="16"
                      fill="#0D924F"
                      fill-opacity="0.3"
                    />
                    <path
                      d="M16.3333 11C16.4659 11 16.5931 11.0527 16.6869 11.1464C16.7807 11.2402 16.8333 11.3674 16.8333 11.5V15.3333H20.6667C20.7993 15.3333 20.9265 15.386 21.0202 15.4798C21.114 15.5735 21.1667 15.7007 21.1667 15.8333C21.1667 15.9659 21.114 16.0931 21.0202 16.1869C20.9265 16.2807 20.7993 16.3333 20.6667 16.3333H16.8333V20.1667C16.8333 20.2993 16.7807 20.4265 16.6869 20.5202C16.5931 20.614 16.4659 20.6667 16.3333 20.6667C16.2007 20.6667 16.0735 20.614 15.9798 20.5202C15.886 20.4265 15.8333 20.2993 15.8333 20.1667V16.3333H12C11.8674 16.3333 11.7402 16.2807 11.6464 16.1869C11.5527 16.0931 11.5 15.9659 11.5 15.8333C11.5 15.7007 11.5527 15.5735 11.6464 15.4798C11.7402 15.386 11.8674 15.3333 12 15.3333H15.8333V11.5C15.8333 11.3674 15.886 11.2402 15.9798 11.1464C16.0735 11.0527 16.2007 11 16.3333 11Z"
                      fill="#3B3B3B"
                    />
                  </svg>
                )}
              </div>
              <div>
                {openFaq === 14 && (
                  <div className="subtitle">
                    Through the voluntary donation pool, donors can support
                    projects whose emission reduction data meets the verified
                    standard.
                  </div>
                )}
              </div>
            </div>
            <div
              className="main__emission-group__faq__card"
              onClick={() =>
                openFaq === 15 ? setOpenFaq(null) : setOpenFaq(15)
              }
            >
              <div className="main__emission-group__faq__card__inner">
                <div>
                  How is my donation used and tracked to ensure it makes an
                  impact?
                </div>
                {openFaq === 15 ? (
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 33 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="16.5"
                      cy="16"
                      r="16"
                      fill="#0D924F"
                      fill-opacity="0.3"
                    />
                    <path
                      d="M11.833 16H21.1663"
                      stroke="#3B3B3B"
                      stroke-width="1.33333"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                ) : (
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 33 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="16.5"
                      cy="16"
                      r="16"
                      fill="#0D924F"
                      fill-opacity="0.3"
                    />
                    <path
                      d="M16.3333 11C16.4659 11 16.5931 11.0527 16.6869 11.1464C16.7807 11.2402 16.8333 11.3674 16.8333 11.5V15.3333H20.6667C20.7993 15.3333 20.9265 15.386 21.0202 15.4798C21.114 15.5735 21.1667 15.7007 21.1667 15.8333C21.1667 15.9659 21.114 16.0931 21.0202 16.1869C20.9265 16.2807 20.7993 16.3333 20.6667 16.3333H16.8333V20.1667C16.8333 20.2993 16.7807 20.4265 16.6869 20.5202C16.5931 20.614 16.4659 20.6667 16.3333 20.6667C16.2007 20.6667 16.0735 20.614 15.9798 20.5202C15.886 20.4265 15.8333 20.2993 15.8333 20.1667V16.3333H12C11.8674 16.3333 11.7402 16.2807 11.6464 16.1869C11.5527 16.0931 11.5 15.9659 11.5 15.8333C11.5 15.7007 11.5527 15.5735 11.6464 15.4798C11.7402 15.386 11.8674 15.3333 12 15.3333H15.8333V11.5C15.8333 11.3674 15.886 11.2402 15.9798 11.1464C16.0735 11.0527 16.2007 11 16.3333 11Z"
                      fill="#3B3B3B"
                    />
                  </svg>
                )}
              </div>
              <div>
                {openFaq === 15 && (
                  <div className="subtitle">
                    CloseCarbon ensures transparency and accountability by
                    sending quarterly feature stories to donors and providing
                    annual reports, especially for large purchases, to track and
                    communicate the impact of donations.
                  </div>
                )}
              </div>
            </div>
            <div
              className="main__emission-group__faq__card"
              onClick={() =>
                openFaq === 16 ? setOpenFaq(null) : setOpenFaq(16)
              }
            >
              <div className="main__emission-group__faq__card__inner">
                <div>How do I get my personalized certificate?</div>
                {openFaq === 16 ? (
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 33 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="16.5"
                      cy="16"
                      r="16"
                      fill="#0D924F"
                      fill-opacity="0.3"
                    />
                    <path
                      d="M11.833 16H21.1663"
                      stroke="#3B3B3B"
                      stroke-width="1.33333"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                ) : (
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 33 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="16.5"
                      cy="16"
                      r="16"
                      fill="#0D924F"
                      fill-opacity="0.3"
                    />
                    <path
                      d="M16.3333 11C16.4659 11 16.5931 11.0527 16.6869 11.1464C16.7807 11.2402 16.8333 11.3674 16.8333 11.5V15.3333H20.6667C20.7993 15.3333 20.9265 15.386 21.0202 15.4798C21.114 15.5735 21.1667 15.7007 21.1667 15.8333C21.1667 15.9659 21.114 16.0931 21.0202 16.1869C20.9265 16.2807 20.7993 16.3333 20.6667 16.3333H16.8333V20.1667C16.8333 20.2993 16.7807 20.4265 16.6869 20.5202C16.5931 20.614 16.4659 20.6667 16.3333 20.6667C16.2007 20.6667 16.0735 20.614 15.9798 20.5202C15.886 20.4265 15.8333 20.2993 15.8333 20.1667V16.3333H12C11.8674 16.3333 11.7402 16.2807 11.6464 16.1869C11.5527 16.0931 11.5 15.9659 11.5 15.8333C11.5 15.7007 11.5527 15.5735 11.6464 15.4798C11.7402 15.386 11.8674 15.3333 12 15.3333H15.8333V11.5C15.8333 11.3674 15.886 11.2402 15.9798 11.1464C16.0735 11.0527 16.2007 11 16.3333 11Z"
                      fill="#3B3B3B"
                    />
                  </svg>
                )}
              </div>
              <div>
                {openFaq === 16 && (
                  <div className="subtitle">
                    Your personalized certificate is automatically downloaded to
                    your computer after each donation. Check the 'Downloads'
                    folder in your browser to find it.
                  </div>
                )}
              </div>
            </div>
            <div
              className="main__emission-group__faq__card"
              onClick={() =>
                openFaq === 17 ? setOpenFaq(null) : setOpenFaq(17)
              }
            >
              <div className="main__emission-group__faq__card__inner">
                <div>
                  What are the benefits of contributing to a Voluntary Donation
                  Pool for emission reduction?
                </div>
                {openFaq === 17 ? (
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 33 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="16.5"
                      cy="16"
                      r="16"
                      fill="#0D924F"
                      fill-opacity="0.3"
                    />
                    <path
                      d="M11.833 16H21.1663"
                      stroke="#3B3B3B"
                      stroke-width="1.33333"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                ) : (
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 33 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="16.5"
                      cy="16"
                      r="16"
                      fill="#0D924F"
                      fill-opacity="0.3"
                    />
                    <path
                      d="M16.3333 11C16.4659 11 16.5931 11.0527 16.6869 11.1464C16.7807 11.2402 16.8333 11.3674 16.8333 11.5V15.3333H20.6667C20.7993 15.3333 20.9265 15.386 21.0202 15.4798C21.114 15.5735 21.1667 15.7007 21.1667 15.8333C21.1667 15.9659 21.114 16.0931 21.0202 16.1869C20.9265 16.2807 20.7993 16.3333 20.6667 16.3333H16.8333V20.1667C16.8333 20.2993 16.7807 20.4265 16.6869 20.5202C16.5931 20.614 16.4659 20.6667 16.3333 20.6667C16.2007 20.6667 16.0735 20.614 15.9798 20.5202C15.886 20.4265 15.8333 20.2993 15.8333 20.1667V16.3333H12C11.8674 16.3333 11.7402 16.2807 11.6464 16.1869C11.5527 16.0931 11.5 15.9659 11.5 15.8333C11.5 15.7007 11.5527 15.5735 11.6464 15.4798C11.7402 15.386 11.8674 15.3333 12 15.3333H15.8333V11.5C15.8333 11.3674 15.886 11.2402 15.9798 11.1464C16.0735 11.0527 16.2007 11 16.3333 11Z"
                      fill="#3B3B3B"
                    />
                  </svg>
                )}
              </div>
              <div>
                {openFaq === 17 && (
                  <div className="subtitle">
                    Through the voluntary donation pool, donors can support
                    projects whose emission reduction data meets the verified
                    standard.
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {modalOpenTwo && (
        <div
          className="goal_modal_container"
          onClick={handleModalCloseTwo}
        ></div>
      )}

      {modalOpenThree && <div className="tag_modal"></div>}
      {fakeData === "89" && (
        <div
          className="fake_data_modal"
        // onClick={handleFakeDataClose}
        ></div>
      )}
      {fabData && (
        <div className="fake_data_modal" onClick={handleFabDataClose}></div>
      )}
      {scheduleSuccess && (
        <div
          className="schedule-success_data_modal"
          onClick={handleScheduleDataClose}
        ></div>
      )}

      {fakeData && (
        <div className="iot-schedule">
          <div className="iot-schedule__title">Schedule IoT installation</div>
          <div className="iot-schedule__subtitle">
            We're excited to help you set up your new device hassle-free.
          </div>
          <div className="iot-schedule__flex">
            {`${moment(`${currentYear}-${currentMonth + 1}`, "YYYY-M").format(
              "MMMM"
            )} ${currentYear}`}

            <div>
              <svg
                className="pointer"
                onClick={handleDecrementMonth}
                width="7"
                height="12"
                viewBox="0 0 7 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.380198 6.36196L5.9532 11.672C6.04619 11.7606 6.16973 11.8101 6.2982 11.8101C6.42667 11.8101 6.55021 11.7606 6.6432 11.672L6.6492 11.666C6.69443 11.623 6.73045 11.5713 6.75507 11.5139C6.77968 11.4566 6.79237 11.3949 6.79237 11.3325C6.79237 11.2701 6.77968 11.2083 6.75507 11.151C6.73045 11.0937 6.69443 11.0419 6.6492 10.999L1.4012 5.99896L6.6492 1.00096C6.69443 0.957991 6.73045 0.906264 6.75507 0.848931C6.77968 0.791598 6.79237 0.729857 6.79237 0.667464C6.79237 0.605071 6.77968 0.54333 6.75507 0.485997C6.73045 0.428664 6.69443 0.376937 6.6492 0.333964L6.6432 0.327964C6.55021 0.239319 6.42667 0.189868 6.2982 0.189868C6.16973 0.189868 6.04619 0.239319 5.9532 0.327964L0.380198 5.63796C0.331186 5.68466 0.292167 5.74082 0.265506 5.80305C0.238845 5.86528 0.225098 5.93227 0.225098 5.99996C0.225098 6.06766 0.238845 6.13465 0.265506 6.19688C0.292167 6.2591 0.331186 6.31527 0.380198 6.36196Z"
                  fill="#667185"
                />
              </svg>
              <svg
                className="pointer"
                onClick={handleIncrementMonth}
                width="7"
                height="12"
                viewBox="0 0 7 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6.6198 5.63804L1.0468 0.328037C0.953814 0.239392 0.830272 0.189941 0.701802 0.189941C0.573331 0.189941 0.44979 0.239392 0.356802 0.328037L0.350802 0.334037C0.305567 0.37701 0.269547 0.428736 0.244934 0.486069C0.22032 0.543402 0.207627 0.605144 0.207627 0.667537C0.207627 0.72993 0.22032 0.791671 0.244934 0.849004C0.269547 0.906337 0.305567 0.958063 0.350802 1.00104L5.5988 6.00104L0.350802 10.999C0.305567 11.042 0.269547 11.0937 0.244934 11.1511C0.22032 11.2084 0.207627 11.2701 0.207627 11.3325C0.207627 11.3949 0.22032 11.4567 0.244934 11.514C0.269547 11.5713 0.305567 11.6231 0.350802 11.666L0.356802 11.672C0.44979 11.7607 0.573331 11.8101 0.701802 11.8101C0.830272 11.8101 0.953814 11.7607 1.0468 11.672L6.6198 6.36204C6.66881 6.31534 6.70783 6.25918 6.73449 6.19695C6.76115 6.13472 6.7749 6.06773 6.7749 6.00004C6.7749 5.93234 6.76115 5.86535 6.73449 5.80312C6.70783 5.7409 6.66881 5.68473 6.6198 5.63804Z"
                  fill="#667185"
                />
              </svg>
            </div>
          </div>

          {renderCalendarGrid()}
          <div className="iot-schedule__agree">
            {!sla && (
              <svg
                width="24"
                height="24"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                onClick={() => setSla(true)}
              >
                <rect
                  x="1"
                  y="1"
                  width="16"
                  height="16"
                  rx="4"
                  stroke="url(#paint0_linear_2889_18043)"
                  stroke-width="1.33333"
                />
                <defs>
                  <linearGradient
                    id="paint0_linear_2889_18043"
                    x1="1"
                    y1="1.36719"
                    x2="20.0689"
                    y2="10.7886"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#006633" />
                    <stop offset="1" stop-color="#02A4CC" />
                  </linearGradient>
                </defs>
              </svg>
            )}

            {sla && (
              <svg
                width="24"
                height="24"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                onClick={() => setSla(false)}
              >
                <rect
                  x="1"
                  y="1"
                  width="16"
                  height="16"
                  rx="4"
                  stroke="url(#paint0_linear_2889_18037)"
                  stroke-width="1.33333"
                />
                <path
                  d="M5.5 9.49992L7.83333 11.8333L12.5 6.83325"
                  stroke="url(#paint1_linear_2889_18037)"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <defs>
                  <linearGradient
                    id="paint0_linear_2889_18037"
                    x1="1"
                    y1="1.36719"
                    x2="20.0689"
                    y2="10.7886"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#006633" />
                    <stop offset="1" stop-color="#02A4CC" />
                  </linearGradient>
                  <linearGradient
                    id="paint1_linear_2889_18037"
                    x1="5.5"
                    y1="6.948"
                    x2="12.5203"
                    y2="11.8039"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#006633" />
                    <stop offset="1" stop-color="#02A4CC" />
                  </linearGradient>
                </defs>
              </svg>
            )}

            <div>
              I {auth?.userInfo?.firstName} {auth?.userInfo?.lastName}, have
              read and understood the terms of the{" "}
              <span
                className="pointer"
                onClick={() => {
                  window.open("/sla", "_blank", "noopener,noreferrer");
                }}
              >
                SLA
              </span>
              , and I confirm that I am a Director/Secretary/Authorised Officer
              of the Company
            </div>
          </div>
          {selectedDate && (
            <div className="iot-schedule__button-group">
              <button onClick={() => setSelectedDate(null)}>Cancel</button>
              <button onClick={handleSchedule}>
                {bookedDateLoading ? "Loading..." : "Save date"}
              </button>
            </div>
          )}
        </div>
      )}

      {fabData && (
        <div className="fake_data">
          <div className="fake_data_title">Welcome to CloseCarbon</div>
          <div className="fake_data_subtitle">Get Carbon emission data...</div>
          <div className="fake_data_content">
            Click the button below to get fabricated carbon emission data
          </div>
          <button
            className="fake_data_button"
            onClick={handleSendFakeData}
            disabled={fakeloading}
          >
            {fakeloading ? "Loading..." : "Get Now"}
          </button>
        </div>
      )}

      {scheduleSuccess && (
        <div className="fake-data-success">
          <div className="fake-data-success__title">
            Date successfully scheduled
          </div>
          <div className="fake-data-success__subtitle">
            You picked {selectedDate} for IoT device installation.
          </div>
          <div className="fake-data-success__subsubtitle">
            Note: Installation time is between 12:00pm - 3:00pm <br /> of
            selected date.
          </div>
        </div>
      )}

      {/* <div className="tag sidebar_tag">
        This shows the process of getting confirmation on the emission tracked
      </div> */}

      {tutorialModal && (
        <div
          className="tutorial-modal"
        // onClick={handleFailedIdVerificationModalClose}
        >
          <div className="tutorial-modal__modal">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7 3H5C4.46957 3 3.96086 3.21071 3.58579 3.58579C3.21071 3.96086 3 4.46957 3 5V7M17 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V7M16 8V10M8 8V10M9 16C9 16 10 17 12 17C14 17 15 16 15 16M12 8V13H11M7 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V17M17 21H19C19.5304 21 20.0391 20.7893 20.4142 20.4142C20.7893 20.0391 21 19.5304 21 19V17"
                stroke="#D42620"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <div className="tutorial-modal__modal__title">Watch Tutorial</div>
            <div className="tutorial-modal__modal__subtitle">
              We'd love to show you around. Ready?
            </div>
            <div className="tutorial-modal__modal__flex">
              <div
                onClick={() => {
                  setTutorialModal(false);
                  localStorage.setItem("onboarded", "true");
                  if (!auth?.userInfo?.iotInstScheduled) {
                    setFakeData(true);
                  }
                }}
              >
                skip
              </div>
              <div
                onClick={() => {
                  setTutorialModal(false);
                  setRunTutorial(true);
                }}
              >
                Yes
              </div>
            </div>
          </div>
        </div>
      )}

      {/* <Kyc /> */}
    </div>
  );
};

export default Home;
